<template>
  <div>
    <div class="registration-page">
      <div class="registration-page-container">
        <div class="section">
          <div class="section-header">
            <h2>
              서비스가입신청
            </h2>
            <!-- 신규 or 기존 -->
            <!-- <span class="dynamic-data-temp info-tag">{{
              openMarketInfo.registrationTypeName
            }}</span> -->
          </div>
          <div class="section-body">
            <ul class="notice-text-list">
              <li class="">
                <strong>LG U<sup>+</sup></strong>는 서비스 가입과 번호이동 처리를 위해 가입자 또는 번호이동 명의자의 정보를 아래와 같이 수집, 이용, 활용하며 
                <strong>LG U<sup>+</sup></strong> 개인정보처리방침에 의해 철저히 관리됩니다.<br/>
                <strong>LG U<sup>+</sup></strong>는 고객님의 개인정보보호를 위하여 최선을 다할 것을 약속 드립니다.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="registration-page">
      <div class="registration-page-container">
        <div class="section">
          <div class="section-header"><h3>유치점 정보</h3></div>
          <div class="section-body">
            <dl class="field-group">
              <dt class="field-label">
                유치관리
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-half">
                  <input
                    type="text"
                    name="postCode"
                    v-model="registration.dealerInfo"
                    class="input-text input-font input-text-disabled input-width-large"
                    placeholder="유치대리점"
                    readonly
                    title="대리점"
                  />
                  <span class="field-group-space"></span>
                  <button
                    @click="searchDealerPopup"
                    title="새창열림"
                    type="button"
                  >
                    대리점 검색
                  </button>
                </div>
                <ul class="notice-text-list">
                  <li class="notice-text">
                    유치점이 고객님께 약속한 사은품 지급이 원활히 이루어질 수 있도록 관리하기 위한 것으로서, 반드시 선택해 주시기 바랍니다.
                  </li>
                </ul>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <SearchDealerPopup @close="searchPopupClose" />
    </div>



    <div class="registration-page">
      <div class="registration-page-container">
        <div class="section">
          <div class="section-header"><h3>개인정보 수집 동의(필수)</h3></div>
          <div class="section-body">
            <dl class="field-group">
              <dt class="field-label">
                구분
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <ul class="notice-text-list">
                    <li class="">
                      기본수집정보
                    </li>
                  </ul>
                </div>
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                수집 및 이용 정보
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <ul class="notice-text-list">
                   <!-- 개인정보 compliance  점검결과  이행점검요청 삭제반영 2025.04.08
                    <li class="">
                      주민등록번호, 여권번호, 운전면허번호, 외국인등록번호 (본인, 대리인 신분확인 이미지 및 내용 포함) ※기간통신사업자는 전기통신사업법 시행령 제65조의2에 의거, 주민등록번호 또는 외국인등록번호가 포함된 자료의 처리가 가능합니다.
                    </li>
                    -->
                    <li class="">
                    · 명의자(양도인) : 성명(상호), 성별, 생년월일, 연락처, 이메일 주소, 청구지 주소, 주민등록주소,내외국인 여부, 개인식별정보(CI/DI), 서비스 가입시 인증된 고객의 모바일 전화번호,본인명의 U+모바일 전화번호<br />
                    </li>
                  </ul>
                </div>
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                수집 및 이용 목적
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      수집 목적 : 본인확인, 본인인증, 실명인증<br />
                      (주)LG유플러스 제공 서비스 이용요금 연체정보 통지, 본인확인(서비스 본인인증, 본인확인 서비스제공, WiFi접속)
                    </li>
                    <li class="notice-text">
                      보유 및 이용기간 :  서비스 가입기간 동안 이용하고 요금 정산, 과 오납 등 분쟁 대비를 위해 해지 후 요금 완납 <em class="primary-text">6개월</em>까지 보유·이용(단, 약관, 정보 통신망 이용 촉진 및 정보 보호 등에 관한 법률, 통신 비밀 보호법, 국세기본법 등 관련 법령에 따라 보존할 필요성이 있는 경우는 규정에 따라 보유합니다.)서비스가입 신청 고객 중 미가입 처리 된 경우, 업무 처리 사유 확인을 위해 가입 서류 작성일로 부터 <em class="primary-text">3개월</em>까지 보유
                    </li>
                  </ul>
                </div>
                <div class="field-control-sub">
                  <div
                    id="agreement_id"
                    class="input-container"
                  >
                    <input
                      id="store-security-setting-agreement"
                      type="checkbox"
                      name="nm_agreement"
                      class="input-checkbox input-text"
                      ref=""
                      v-model="agreement.personalInfoEssential"
                    />
                    <label
                      for="store-security-setting-agreement"
                      class="input-label"
                      ><em class="primary-text">(필수)</em> 개인정보 수집 및 이용에 동의합니다.</label
                    >
                  </div>
                  <div class="field-control-sub">
                    <ul class="notice-text-list">
                      <li class="notice-text">
                        위 개인정보 수집에 대한 동의를 거부할 권리가 있으며, 동의 거부 시에는 온세일홈의 이용이 제한될 수 있습니다.
                        더 자세한 내용에 대해서는 [온세일홈 개인정보처리방침]을 참고하시길 바랍니다.
                      </li>
                    </ul>
                  </div>
                </div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>



<!-- 개인정보 Compliance 점검결과 2025.02.11
    <div class="registration-page">
      <div class="registration-page-container">
        <div class="section">
          <div class="section-header"><h3>개인정보 수집 동의(선택)</h3></div>
          <div class="section-body">
            <dl class="field-group">
              <dt class="field-label">
                구분
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <ul class="notice-text-list">
                    <li class="">
                      부가적 수집정보
                    </li>
                  </ul>
                </div>
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                수집 및 이용,제공정보
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <ul class="notice-text-list">
                    <li class="">
                      일반전화번호, 이메일주소
                    </li>
                  </ul>
                </div>
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                수집 및 제공 목적
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      수집 목적
                    </li>
                    <li class="">
                      ■ 일반전화번호 : 원활한 연락을 위한 추가적 전화번호<br/>
                      ■ 이메일주소 : 이메일로 계약사실 및 요금확인서 수령시 필요 정보
                    </li>
                    <li class="notice-text">
                      고객의 개인정보는 서비스 가입기간동안 이용 · 보관함을 원칙으로 하고 요금정산, 과 · 오납 등에 관한 분쟁에 대비하기 위하여 
                      <strong>서비스 해지 또는 요금완납 후 6개월까지 </strong>보유 · 이용합니다.
                    </li>
                  </ul>
                </div>
                <div class="field-control-sub">
                  <div
                    id="agreement_id_optional"
                    class="input-container"
                  >
                    <input
                      id="agreeForCollection"
                      type="checkbox"
                      name="sel"
                      class="input-checkbox input-text"
                      ref=""
                      v-model="agreement.personalInfoOptional"
                    />
                    <label
                      for="agreeForCollection"
                      class="input-label"
                      ><em class="primary-text">(선택)</em> 개인정보 수집 이용에 동의합니다.</label
                    >
                  </div>
                </div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
-->

    <div class="registration-page">
      <div class="registration-page-container">
        <div class="section">
          <div class="section-header"><h3>개인정보처리 위탁 안내</h3></div>
          <div class="section-body">
            <ul class="notice-text-list">
              <li class="">
                (1) 회사는 보다 나은 서비스 제공과 고객편의 제공 등 업무 수행을 원활하게 하기 위하여 외부 전문업체에 고객의 개인정보에 대한 처리업무를 위탁하고 있습니다.<br/><br/>
                (2) 회사는 개인정보 처리위탁의 경우 계약 등을 통하여 법상 개인정보 보호규정의 준수, 개인정보에 관한 비밀유지, 제3자 제공 금지 및 사고 발생 시의 책임부담, 위탁기간, 개인정보의 반환 및 파기, 위탁업무 수행목적 외 개인정보 처리금지, 안전성 확보조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등을 명확히 규정하고 당해 계약 내용을 서면 또는 전자적으로 보관합니다.<br/><br/>
                (3) 회사가 고객의 개인정보를 처리 위탁하는 경우 그 수탁자와 위탁업무 내용은 아래와 같습니다. <br/>
  수탁사 : NICE평가정보㈜,에스씨아이평가정보(주),KCB / 위탁업무내용 : 주민등록번호대체수단생성업무대행<br/>
  수탁사 : 한국모바일인증,KCB,에스씨아이평가정보(주),NICE평가정보㈜,엔에이치엔케이씨피 주식회사 등 8개사 / 위탁업무 : 본인확인정보처리 및 본인확인 업무대행
              </li>
            </ul>
          </div>
           <!--
          <div class="section-body">
            <dl class="field-group">
              <dt class="field-label">
                구분
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <ul class="notice-text-list">
                    <li class="">
                      기본수집정보
                    </li>
                  </ul>
                </div>
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                수집 및 이용,제공정보
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <ul class="notice-text-list">
                    <li class="">
                      한국모바일인증(KMC)<br/>
                      NICE평가정보
                    </li>
                  </ul>
                </div>
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                수집 및 제공 목적
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <ul class="notice-text-list">
                    <li class="">
                      본인인증, 청약 내용 확인 서비스 제공
                    </li>
                  </ul>
                </div>
                <div class="field-control-sub">
                  <div
                    id="id_agreement_Entrust"
                    class="input-container"
                  >
                    <input
                      id="agreeForConsignment"
                      type="checkbox"
                      name="sel"
                      class="input-checkbox input-text"
                      ref=""
                      v-model="agreement.personalInfoEntrust"
                    />
                    <label
                      for="agreeForConsignment"
                      class="input-label"
                      >개인정보 처리 위탁에 동의합니다.</label
                    >
                  </div>
                </div>
              </dd>
            </dl>
          </div>
           -->
        </div>
      </div>
    </div>

    <div class="registration-page">
      <div class="registration-page-container">
        <div class="section">
          <div class="section-header"><h3>가입자 정보</h3></div>
          <div class="section-body">
            <dl class="field-group">
              <dt class="field-label">
                성명
              </dt>
              <dd class="field-control">
                <input
                  id="name"
                  type="text"
                  @input="onlyText"
                  v-model="registration.name"
                  name="name"
                  autocomplete="off"
                  class="input-text input-font"
                  title="가입자 성명"
                />
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                생년월일
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                <select
                  id="year"
                  name="year"
                  class="input-width-xxsmall"
                  v-model="registration.birthYear"
                >
                  <option
                    v-for="year in yearList"
                    :value="year"
                    :key="year"
                    >{{ year }}</option
                  >
                </select>
                년 
                <select
                  id="month"
                  name="month"
                  class="input-width-xxsmall"
                  v-model="registration.birthMonth"
                >
                  
                  <option value="01"> 01 </option><option value="02"> 02 </option><option value="03"> 03 </option><option value="04"> 04 </option>
                  <option value="05"> 05 </option><option value="06"> 06 </option><option value="07"> 07 </option><option value="08"> 08 </option>
                  <option value="09"> 09 </option><option value="10"> 10 </option><option value="11"> 11 </option><option value="12"> 12 </option>
                </select>
                월 
                <select
                  id="date"
                  name="date"
                  class="input-width-xxsmall"
                  v-model="registration.birthDate"
                >
                  
                  <option value="01"> 01 </option><option value="02"> 02 </option><option value="03"> 03 </option><option value="04"> 04 </option>
                  <option value="05"> 05 </option><option value="06"> 06 </option><option value="07"> 07 </option><option value="08"> 08 </option>
                  <option value="09"> 09 </option><option value="10"> 10 </option><option value="11"> 11 </option><option value="12"> 12 </option>
                  <option value="13"> 13 </option><option value="14"> 14 </option><option value="15"> 15 </option><option value="16"> 16 </option>
                  <option value="17"> 17 </option><option value="18"> 18 </option><option value="19"> 19 </option><option value="20"> 20 </option>
                  <option value="21"> 21 </option><option value="22"> 22 </option><option value="23"> 23 </option><option value="24"> 24 </option>
                  <option value="25"> 25 </option><option value="26"> 26 </option><option value="27"> 27 </option><option value="28"> 28 </option>
                  <option value="29"> 29 </option><option value="30"> 30 </option><option value="31"> 31 </option>
                </select>
                일
                </div>
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                성별
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <div
                    id="radio_sex_male"
                    class="input-container input-horizontal"
                  >
                    <input
                      id="sex_male"
                      type="radio"
                      name="sex"
                      value="M"
                      class="input-radio"
                      title="남성"
                      ref="sex_male"
                      checked=true
                      v-model="registration.sex"
                      :disabled="isAuth"
                    />
                    <label
                      for="sex_male"
                      class="input-label"
                      >남</label
                    >
                  </div>
                  <div
                    id="radio_sex_female"
                    class="input-container input-horizontal"
                  >
                    <input
                      id="sex_female"
                      type="radio"
                      name="sex"
                      value="F"
                      class="input-radio"
                      title="여성"
                      v-model="registration.sex"
                      :disabled="isAuth"
                    />
                    <label for="sex_female" class="input-label"
                      >여</label
                    >
                  </div>
                </div>                
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                내/외국인 구분
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <div
                    id="radio_local_foreigner"
                    class="input-container input-horizontal"
                  >
                    <input
                      id="radio_local"
                      type="radio"
                      name="local_foreigner"
                      value="L"
                      class="input-radio"
                      title="내국인"
                      ref="ref_local"
                      checked=true
                      v-model="registration.isDomestic"
                      :disabled="isAuth"
                    />
                    <label
                      for="radio_local"
                      class="input-label"
                      >내국인</label
                    >
                  </div>
                  <div
                    id="radio_local_foreigner"
                    class="input-container input-horizontal"
                  >
                    <input
                      id="radio_foreigner"
                      type="radio"
                      name="local_foreigner"
                      value="F"
                      class="input-radio"
                      title="외국인"
                      v-model="registration.isDomestic"
                      :disabled="isAuth"
                    />
                    <label for="radio_foreigner" class="input-label"
                      >외국인</label
                    >
                  </div>
                </div>
                
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                인증방법
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <button
                    @click="clickSMS"
                    title="새창열림"
                    type="button"
                  >
                    SMS 인증
                  </button>
                  <span class="field-group-space"></span>
                  <button
                    @click="openIPIN"
                    title="새창열림"
                    type="button"
                  >
                    IPIN 인증
                  </button>
                </div>
                <div class="field-control-sub">
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      가입자 본인을 확인하기 위한 절차로 반드시 입력자 본인이 인증하여야 합니다. 타인의 명의를 도용할 경우 사문서 위조(형법 제231조)등 관련 법률에 의거하여 처벌을 받을 수 있습니다.
                    </li>
                  </ul>
                </div>
              </dd>
            </dl>


            <div v-if="authCd === 'SMS' || authCd === 'KMC'">
              <dl class="field-group">
                <dt class="field-label">
                  보안문자
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <!-- captcha -->
                    <div class="form">
                      <div class="row">
                        <my-captcha :callSuccess="captchaOk"></my-captcha>
                      </div>
                    </div>
                  </div>
                </dd>
              </dl>


              <dl class="field-group">
                <dt class="field-label">
                  이동전화
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <select
                      id="phonCorp"
                      name="sel_phonCorp"
                      class="input-width-xsmall"
                      v-model="registration.phonCorp"
                    >
                      <option value="LGT" selected>LG U+</option>
                      <option value="LGM">LG U+알뜰폰</option>
                      <option value="SKT">SKT</option>
                      <option value="KTF">KT</option>
                      <option value="SKM">SK알뜰폰</option>
                      <option value="KTM">KT알뜰폰</option>
                    </select>

                    <span class="field-group-space"></span>

                    <select
                            name="trno_selectbox"
                            class="input-width-xxsmall"
                            title="지역번호선택"
                            v-model="registration.phonNo_trno"
                    >
                      <option value="">선택</option>
                      <option value="010"> 010 </option><option value="011"> 011 </option><option value="016"> 016 </option><option value="017"> 017 </option>
                      <option value="018"> 018 </option><option value="019"> 019 </option>
                    </select>

                    <input
                            id="txNo_phonNo"
                            type="text"
                            maxlength="4"
                            @input="onlyNumber"
                            name="nm_txNo_phonNo"
                            v-model="registration.phonNo_txno"
                            autocomplete="off"
                            class="input-text input-font input-width-xxsmall"
                            title="일반전화 입력"
                            ref="ref_phonNo"
                    />
                    -
                    <input
                            id="tsNo_phonNo"
                            type="text"
                            maxlength="4"
                            @input="onlyNumber"
                            name="nm_tsNo_phonNo"
                            v-model="registration.phonNo_tsno"
                            autocomplete="off"
                            class="input-text input-font input-width-xxsmall"
                            title="일반전화 입력"
                            ref="ref_phonNo"
                    />

<!--                    <input-->
<!--                      id="phonNo"-->
<!--                      type="text"-->
<!--                      maxlength="12"-->
<!--                      @input="onlyNumber"-->
<!--                      name="phonNo"-->
<!--                      v-model="registration.phonNo"-->
<!--                      class="input-text input-font"-->
<!--                      placeholder="'-' 없이 숫자만 입력"-->
<!--                      title="이동전화 입력"-->
<!--                      ref="ref_phonNo"-->
<!--                    />-->

                    <span class="field-group-space"></span>

                    <button
                      @click="requestAuth"
                      title="인증요청"
                      type="button"
                    >
                      인증 요청
                    </button>
                  </div>
                </dd>
              </dl>

              <dl class="field-group" v-if="showAuthTab">
                <dt class="field-label">
                  인증번호
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    
                    <input
                      id="authNo"
                      type="text"
                      maxlength="6"
                      @input="onlyNumber"
                      name="authNo"
                      v-model="authNo"
                      class="input-text input-font"
                      placeholder="6자리 인증번호"
                      title="인증번호"
                      ref="ref_authNo"
                      :disabled="isAuth"
                    />
<!--                    <input-->
<!--                            id="authNo"-->
<!--                            type="text"-->
<!--                            maxlength="6"-->
<!--                            @input="onlyNumber"-->
<!--                            name="authNo"-->
<!--                            v-model="authNo"-->
<!--                            class="input-text input-font"-->
<!--                            placeholder="6자리 인증번호"-->
<!--                            title="인증번호"-->
<!--                            ref="ref_authNo"-->
<!--                    />-->

                    <span class="field-group-space"></span>

<!--                    <button-->
<!--                      @click="validateAuthNo"-->
<!--                      title="확인"-->
<!--                      type="button"-->
<!--                    >-->
                      <button
                              @click="validateAuthNo"
                              title="확인"
                              type="button"
                              v-if="!isAuth"
                      >
                      확인
                    </button>
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div v-if="!isNew && homeCntnFlag">
<!--    <div v-if="!isNew">-->

      <div class="registration-page">
        <div class="registration-page-container">
          <div class="section">
            <div class="section-header"><h3>사용중인 상품 정보</h3></div>
            <div class="section-body">
              <ul>
                <li v-for="homeCntn in registration.homeCntnInfo"
                    v-bind:key="homeCntn.cnvgNo"
                    :value="homeCntn.cnvgNo">
                  <div
                          :id="`div-homeCntn-${homeCntn.cnvgNo}`"
                          class="input-container input-horizontal"
                  >
                    <input
                            :id="'homeCntn-' + homeCntn.cnvgNo"
                            type="radio"
                            name="radio-homeCntn"
                            value=true
                            class="input-radio"
                            v-model="registration.homeCntnStatus['homeCntn-' + homeCntn.cnvgNo]"
                            :disabled="homeCntn.isDisable"
                            @click="clickHomeCntn"
                    />
                    <label
                            :for="'homeCntn-' + homeCntn.cnvgNo"
                            class="input-label"
                    >상품명: {{homeCntn.prodNm}} <br/>
                      설치 주소 : {{homeCntn.estbAllAddr}} <br/>
                      비고      : {{homeCntn.tmpComment}}</label
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="registration-page">
        <div class="registration-page-container">
          <div class="section">
            <div class="section-header"><h3>변경할 상품 정보</h3></div>
            <div class="section-body">
              <dl class="field-group">
                <dt class="field-label">
                  상품명
                </dt>
                <dd class="field-control">
                  <input
                          type="text"
                          name="address1"
                          v-model="estbProdNm"
                          class="input-text input-width-xlarge input-font input-text-disabled"
                          readonly
                          title="주소"
                          placeholder="상품명"
                  />

                </dd>
              </dl>

              <dl class="field-group">
                <dt class="field-label">
                  설치주소
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <input
                            type="text"
                            name="address1"
                            v-model="estbAllAddr"
                            class="input-text input-width-xlarge input-font input-text-disabled"
                            readonly
                            title="주소"
                            placeholder="설치주소"
                    />
                  </div>

                </dd>
              </dl>


            </div>
          </div>
        </div>
      </div>

    </div>


    <div class="registration-page">
      <div class="registration-page-container">
        <div class="section">
          <div class="section-header"><h3>서비스 선택</h3></div>
          <div class="section-body">
            <dl class="field-group">
              <dt class="field-label">
                서비스구분
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <div
                    id="radio_service_divs_home"
                    class="input-container input-horizontal"
                  >
                    <input
                      id="service_home"
                      type="radio"
                      name="service"
                      value=true
                      class="input-radio"
                      title="홈"
                      ref="svc_home"
                      v-model="service.isHome"
                    />
                    <label
                      for="service_home"
                      class="input-label"
                      >홈</label
                    >
                  </div>
                  <div
                    id="radio_service_divs_soho"
                    class="input-container input-horizontal"
                  >
                    <input
                      id="service_soho"
                      type="radio"
                      name="service"
                      value=false
                      class="input-radio"
                      title="소호"
                      v-model="service.isHome"
                      @change="clickIsHome"
                    />
                    <label for="service_soho" class="input-label"
                      >소호</label
                    >
                  </div>
                </div>  
              
              </dd>
              
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                서비스 선택
              </dt>
              <dd class="field-control">
                <div
                  id="checkbox-container-svc-internet"
                  class="input-container"
                >
                  <input
                    id="chk_internet"
                    type="checkbox"
                    v-model="service.chkInternet"
                    :disabled="service.chkExclusive"
                    name="svc_internet"
                    class="input-checkbox input-text"
                  />
                  <label
                    for="chk_internet"
                    class="input-label"
                    >U+ 인터넷(초고속인터넷)</label
                  >
                </div>
                <div
                  id="checkbox-container-svc-internet-call"
                  class="input-container"
                >
                  <input
                    id="chk_internet_call"
                    v-model="service.chkInternetPhone"
                    :disabled="service.chkExclusive"
                    type="checkbox"
                    name="svc_internet_call"
                    class="input-checkbox input-text"
                  />
                  <label
                    for="chk_internet_call"
                    class="input-label"
                    >U+ 070(인터넷전화)</label
                  >
                </div>
                <div
                  id="checkbox-container-svc-tv"
                  class="input-container"
                >
                  <input
                    id="chk_tv"
                    type="checkbox"
                    v-model="service.chkTV"
                    :disabled="service.chkExclusive"
                    name="svc_tv"
                    class="input-checkbox input-text"
                  />
                  <label
                    for="chk_tv"
                    class="input-label"
                    >U+ TV</label
                  >
                </div>
                <div
                  id="checkbox-container-svc-iot"
                  class="input-container"
                >
                  <input
                    id="chk_iot"
                    v-model="service.chkIoT"
                    :disabled="service.chkExclusive"
                    type="checkbox"
                    name="svc_iot"
                    class="input-checkbox input-text"
                  />
                  <label
                    for="chk_iot"
                    class="input-label"
                    >U+ IoT@Home</label
                  >
                </div>
                <div
                  id="checkbox-container-svc-exclusive"
                  class="input-container"
                >
                  <input
                    id="chk_exclusive"
                    v-model="service.chkExclusive"
                    value=true
                    type="checkbox"
                    name="svc_exclusive"
                    class="input-checkbox input-text"
                    @change="clickCheckExclusive"
                  />
                  <label
                    for="chk_exclusive"
                    class="input-label"
                    >부가단독</label
                  >
                </div>
              </dd>
            </dl>
            <div v-if="service.chkExclusive">
              <dl class="field-group" >
                <dt class="field-label">
                  단독맘카
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <div
                      id="div_radio_Exclusive"
                      class="input-container input-horizontal"
                    >
                      <input
                        id="radio_exclusive"
                        type="radio"
                        name="name_radio_exclusive"
                        class="input-radio"
                        title="홈"
                        ref="ref_radio_exclusive"
                        v-model="service.chkTrue"
                        value=true
                      />
                      <label
                        for="radio_exclusive"
                        class="input-label"
                        >신청</label
                      >
                    </div>
                  </div>
                </dd>
              </dl>
            </div>

            <div v-if="service.chkInternetPhone">
              <dl class="field-group" >
                <dt class="field-label">
                  번호 이동 신청 여부
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <div
                      id="div_radio_moveY"
                      class="input-container input-horizontal"
                    >
                      <input
                        id="radio_moveY"
                        type="radio"
                        name="name_radio_move"
                        value=true
                        class="input-radio"
                        v-model="service.moveYn"
                        title="홈"
                        ref="ref_radio_moveY"
                        :disabled="!service.isHome"
                      />
                      <label
                        for="radio_moveY"
                        class="input-label"
                        >신청</label
                      >
                    </div>
                    <div
                      id="div_radio_moveN"
                      class="input-container input-horizontal"
                    >
                      <input
                        id="radio_moveN"
                        type="radio"
                        name="name_radio_move"
                        value=false
                        class="input-radio"
                        v-model="service.moveYn"
                        title="홈"
                        ref="ref_radio_moveN"
                        @change="clickMoveYn"
                      />
                      <label
                        for="radio_moveN"
                        class="input-label"
                        >미신청</label
                      >
                    </div>
                  </div>
                </dd>
              </dl>
              <div v-if="!service.isHome && service.chkInternetPhone">
                <dl class="field-group" >
                  <dt class="field-label">
                    회선 수
                  </dt>
                  <dd class="field-control">
                    <input
                            id="id_line_cnt"
                            type="text"
                            maxlength="3"
                            @input="onlyNumber"
                            name="nm_line_cnt"
                            v-model="service.line_cnt"
                            class="input-text input-font input-width-xxsmall"
                            ref="ref_line_cnt"
                    />
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="registration-page">
      <div class="registration-page-container">
        <div class="section">
          <div class="section-header"><h3>상세정보입력</h3></div>
          <div class="section-body">
            <!-- 23-07-03 현행화 3단계 일반전화 제외 -->
            <dl style="display: none" class="field-group"> 
              <dt class="field-label">
                일반전화
              </dt>
              <dd class="field-control">
                <select
                        name="trno_selectbox"
                        class="input-width-xxsmall"
                        title="지역번호선택"
                        v-model="registration.tlno_trno"
                        id="id_trno"
                >
                  <option value="">선택</option>
                  <option value="02"> 02 </option><option value="031"> 031 </option><option value="032"> 032 </option><option value="033"> 033 </option>
                  <option value="041"> 041 </option><option value="042"> 042 </option><option value="043"> 043 </option><option value="044"> 044 </option>
                  <option value="051"> 051 </option>
                  <option value="052"> 052 </option><option value="053"> 053 </option><option value="054"> 054 </option><option value="055"> 055 </option>
                  <option value="061"> 061 </option><option value="062"> 062 </option><option value="063"> 063 </option><option value="064"> 064 </option>
                  <option value="0505"> 0505 </option><option value="0506"> 0506 </option><option value="0130"> 0130 </option><option value="0303"> 0303 </option>
                  <option value="0502"> 0502 </option><option value="070"> 070 </option>
                </select>

                <input
                        id="id_txno"
                        type="text"
                        maxlength="4"
                        @input="onlyNumber"
                        name="nm_tlno_txNo"
                        v-model="registration.tlno_txno"
                        autocomplete="off"
                        class="input-text input-font input-width-xxsmall"
                        title="일반전화 입력"
                        ref="ref_phonNo"
                />
                -
                <input
                        id="id_tsno"
                        type="text"
                        maxlength="4"
                        @input="onlyNumber"
                        name="nm_tlno_tsNo"
                        v-model="registration.tlno_tsno"
                        autocomplete="off"
                        class="input-text input-font input-width-xxsmall"
                        title="일반전화 입력"
                        ref="ref_phonNo"
                />
<!--                <input-->
<!--                  id="tlno"-->
<!--                  type="text"-->
<!--                  maxlength="12"-->
<!--                  @input="onlyNumber"-->
<!--                  name="tlno"-->
<!--                  v-model="registration.tlno"-->
<!--                  autocomplete="off"-->
<!--                  class="input-text input-font"-->
<!--                  placeholder="'-' 없이 숫자만 입력"-->
<!--                  title="일반전화 입력"-->
<!--                  ref="ref_phonNo"-->
<!--                />-->
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                인증 이동전화
              </dt>
              <dd class="field-control">
                <select
                        name="trno_selectbox"
                        class="input-width-xxsmall"
                        title="지역번호선택"
                        v-model="registration.authTlno_trno"
                        id="id_authTlno_trno"
                >
                  <option value="">선택</option>
                  <option value="010"> 010 </option><option value="011"> 011 </option><option value="016"> 016 </option><option value="017"> 017 </option>
                  <option value="018"> 018 </option><option value="019"> 019 </option><option value="0505"> 0505 </option><option value="0506"> 0506 </option>
                  <option value="0130"> 0130 </option><option value="0303"> 0303 </option><option value="0502"> 0502 </option>
                </select>

                <input
                        id="id_authTlno_txno"
                        type="text"
                        maxlength="4"
                        @input="onlyNumber"
                        name="nm_authTlno_txNo"
                        v-model="registration.authTlno_txno"
                        autocomplete="off"
                        class="input-text input-font input-width-xxsmall"
                        title="일반전화 입력"
                        ref="ref_phonNo"
                />
                -
                <input
                        id="id_authTlno_tsno"
                        type="text"
                        maxlength="4"
                        @input="onlyNumber"
                        name="nm_authTlno_tsNo"
                        v-model="registration.authTlno_tsno"
                        autocomplete="off"
                        class="input-text input-font input-width-xxsmall"
                        title="일반전화 입력"
                        ref="ref_phonNo"
                />
<!--                <input-->
<!--                  id="phonNo_auth"-->
<!--                  type="text"-->
<!--                  maxlength="12"-->
<!--                  @input="onlyNumber"-->
<!--                  name="authTlno"-->
<!--                  v-model="registration.authTlno"-->
<!--                  autocomplete="off"-->
<!--                  class="input-text input-font"-->
<!--                  placeholder="'-' 없이 숫자만 입력"-->
<!--                  title="일반전화 입력"-->
<!--                  ref="ref_phonNo_auth"-->
<!--                />-->
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                e-Mail
              </dt>
              <dd class="field-control">
                <div>
                    <span class="m-input-half">
                      <input
                        type="text"
                        @input="onlyText"
                        ref="ref_emailId"
                        name="emailId"
                        v-model="registration.emailId"
                        placeholder="email ID 입력"
                        class="input-text input-width-small input-font"
                        title="이메일 아이디 입력"
                      />
                      <span class="field-group-space">@</span>
                      <select
                        name="emailDomainSelect"
                        class="input-width-xsmall"
                        title="이메일 도메인 선택"
                        v-model="selectedEmailDomain"
                        @change="chgEmailDomain()"
                      >
                        <option value="">직접입력</option>
                        <option
                          v-for="emailDomain in emailDomainList"
                          v-bind:key="emailDomain.domainDetail"
                          :value="emailDomain.domainDetail"
                        >
                          {{ emailDomain.domainNm }}
                        </option>
                      </select>
                    </span>
                    <span class="m-input-half">
                      <input
                        ref="ref_emailDomain"
                        type="text"
                        v-model="registration.emailDomain"
                        @input="onlyText"
                        name="emailDomain"
                        class="input-text input-width-small input-font"
                        title="이메일 도메인 직접입력"
                      />
                      <button
                        type="submit"
                        ref="ref_submitEmail"
                        @click="submitEmail"
                      >
                        확인
                      </button>
                    </span>
                  </div>
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                주소
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-half">
                  <input
                    type="text"
                    name="postCode"
                    v-model="registration.crplZpcd"
                    class="input-text input-width-xsmall input-font input-text-disabled"
                    readonly
                    placeholder="우편번호"
                    title="우편번호"
                  />
                  <span class="field-group-space"></span>
                  <button
                    @click="zipcodeAddressPop"
                    title="새창열림"
                    type="button"
                    ref="ref_zipcodeAddressPop"
                  >
                    주소찾기
                  </button>
                </div>
                <div class="field-control-sub">
                  <input
                    type="text"
                    name="address1"
                    v-model="registration.crplAddr"
                    class="input-text input-width-xlarge input-font input-text-disabled"
                    readonly
                    title="주소"
                    placeholder="주소"
                  />
                </div>
                <div class="field-control-sub">
                  <input
                    type="text"
                    name="address2"
                    v-model="registration.crplDadr"
                    class="input-text input-width-xlarge input-font input-text-disabled"
                    readonly
                    title="주소"
                    placeholder="상세주소"
                  />
                </div>
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                기타요청사항
              </dt>
              <dd class="field-control">
                <textarea
                  id="leave-additional-request"
                  name="addReqMttrCntn"
                  @input="onlyText"
                  rows="5"
                  class="input-text input-font"
                  placeholder="요청사항을 입력하세요"
                  title="추가요청사항 입력"
                  v-model="registration.spclDet"
                />
              </dd>
            </dl>

          </div>
        </div>
      </div>
      <ZipcodeDirectPopup @close="popupClose" />
      
    </div>


    <div class="registration-page" v-if="service.moveYn">
      <div class="registration-page-container">
        <div class="section">
          <div class="section-header"><h3>번호이동 신청정보</h3></div>
          <div class="section-body">
            <dl class="field-group">
              <dt class="field-label">
                번호이동 전화번호
              </dt>
              <dd class="field-control">
                <select
                        name="trno_selectbox"
                        class="input-width-xxsmall"
                        title="지역번호선택"
                        v-model="registration.moveInfo.trno"
                        id="id_moveInfo_trno"
                        :disabled="registration.moveInfo.ischeck"
                >
                  <option value="">선택</option>
                  <option value="02"> 02 </option><option value="031"> 031 </option><option value="032"> 032 </option><option value="033"> 033 </option>
                  <option value="041"> 041 </option><option value="042"> 042 </option><option value="043"> 043 </option><option value="044"> 044 </option>
                  <option value="051"> 051 </option>
                  <option value="052"> 052 </option><option value="053"> 053 </option><option value="054"> 054 </option><option value="055"> 055 </option>
                  <option value="061"> 061 </option><option value="062"> 062 </option><option value="063"> 063 </option><option value="064"> 064 </option>
                  <option value="0505"> 0505 </option><option value="0506"> 0506 </option><option value="0130"> 0130 </option><option value="0303"> 0303 </option>
                  <option value="0502"> 0502 </option><option value="070"> 070 </option>
                </select>

                <input
                  id="id_moveInfo_txno"
                  type="text"
                  maxlength="4"
                  @input="onlyNumber"
                  name="nm_txNo_forMove"
                  v-model="registration.moveInfo.txno"
                  autocomplete="off"
                  class="input-text input-font input-width-xxsmall"
                  title="일반전화 입력"
                  ref="ref_phonNo"
                  :disabled="registration.moveInfo.ischeck"
                />
                -
                <input
                        id="id_moveInfo_tsno"
                        type="text"
                        maxlength="4"
                        @input="onlyNumber"
                        name="nm_tsNo_forMove"
                        v-model="registration.moveInfo.tsno"
                        autocomplete="off"
                        class="input-text input-font input-width-xxsmall"
                        title="일반전화 입력"
                        ref="ref_phonNo"
                        :disabled="registration.moveInfo.ischeck"

                />
                <button
                  type="submit"
                  ref="ref_checkNumbers"
                  @click="checkNumbers"
                  v-if="!registration.moveInfo.ischeck"
                >
                  번호확인
                </button>
                <span class="field-group-space"></span>
                <button
                  type="submit"
                  ref="ref_editNumbers"
                  @click="editNumbers"
                  v-if="registration.moveInfo.ischeck"
                >
                  번호수정
                </button>
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                변경전 사업자
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-half">
                  <input
                    type="text"
                    name="beforeBuisness"
                    v-model="registration.moveInfo.beforeBuisness"
                    class="input-text input-font input-text-disabled input-width-large"
                    placeholder="변경전 사업자"
                    readonly
                    title="변경전 사업자"
                  />
                  
                </div>
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                명의인과 관계
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-half">
                  <div
                    id="radio_relationship"
                    class="input-container input-horizontal"
                  >
                    <input
                      id="relationship"
                      type="radio"
                      name="nm_relationship"
                      checked=true
                      class="input-radio"
                      title="본인"
                    />
                    <label for="relationship" class="input-label"
                      >본인</label
                    >
                  </div>
                  
                  <button
                  type="submit"
                  ref="ref_copyInfo"
                  @click="copyInfo"
                >
                  가입자정보 복사입력
                </button>
                </div>
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                명의인 이름
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-half">
                  <input
                    type="text"
                    name="titleHolderName"
                    v-model="registration.moveInfo.titleHolder.name"
                    class="input-text input-font input-text-disabled input-width-xsmall"
                    placeholder="명의인 이름"
                    readonly
                    title="명의인 이름"
                  />
                </div>
              </dd>
            </dl>

            <dl style="display: none" class="field-group">
              <dt class="field-label">
                명의인 일반전화
              </dt>
              <dd class="field-control">
                <select
                        name="trno_selectbox"
                        class="input-width-xxsmall"
                        title="지역번호선택"
                        v-model="registration.moveInfo.titleHolder.tlno_trno"
                        id="id_titleholder_tlno_trno"
                        disabled
                >
                  <option value="02"> 02 </option><option value="031"> 031 </option><option value="032"> 032 </option><option value="033"> 033 </option>
                  <option value="041"> 041 </option><option value="042"> 042 </option><option value="043"> 043 </option><option value="044"> 044 </option>
                  <option value="051"> 051 </option>
                  <option value="052"> 052 </option><option value="053"> 053 </option><option value="054"> 054 </option><option value="055"> 055 </option>
                  <option value="061"> 061 </option><option value="062"> 062 </option><option value="063"> 063 </option><option value="064"> 064 </option>
                  <option value="0505"> 0505 </option><option value="0506"> 0506 </option><option value="0130"> 0130 </option><option value="0303"> 0303 </option>
                  <option value="0502"> 0502 </option><option value="070"> 070 </option>
                </select>

                <input
                        id="id_titleholder_tlno_txno"
                        type="text"
                        maxlength="4"
                        @input="onlyNumber"
                        name="nm_atitleholder_tlno_txNo"
                        v-model="registration.moveInfo.titleHolder.tlno_txno"
                        autocomplete="off"
                        class="input-text input-font input-width-xxsmall input-text-disabled"
                        title="일반전화 입력"
                        ref="ref_phonNo"
                        disabled
                />
                -
                <input
                        id="id_titleholder_tlno_tsno"
                        type="text"
                        maxlength="4"
                        @input="onlyNumber"
                        name="nm_titleholder_tlno_tsNo"
                        v-model="registration.moveInfo.titleHolder.tlno_tsno"
                        autocomplete="off"
                        class="input-text input-font input-width-xxsmall input-text-disabled"
                        title="일반전화 입력"
                        ref="ref_phonNo"
                        disabled
                />
<!--                <input-->
<!--                  id="tlno_forMove_titleHolder"-->
<!--                  type="text"-->
<!--                  maxlength="8"-->
<!--                  @input="onlyNumber"-->
<!--                  name="tlno"-->
<!--                  v-model="registration.moveInfo.titleHolder.tlno"-->
<!--                  class="input-text input-font input-text-disabled"-->
<!--                  placeholder="'-' 없이 숫자만 입력"-->
<!--                  title="명의인 일반전화 입력"-->
<!--                  ref="ref_tlno"-->
<!--                  disabled=true-->
<!--                />-->

              </dd>
            </dl>


            <dl class="field-group">
              <dt class="field-label">
                명의인 이동전화
              </dt>
              <dd class="field-control">
                <select
                  id="titleHolderPhonCorp"
                  name="sel_titleHolderPhonCorp"
                  class="input-width-xsmall"
                  v-model="registration.moveInfo.titleHolder.phonCorp"
                >
                  <option value="LGT" selected>LG U+</option>
                  <option value="LGM">LG U+알뜰폰</option>
                  <option value="SKT">SKT</option>
                  <option value="KTF">KT</option>
                  <option value="SKM">SK알뜰폰</option>
                  <option value="KTM">KT알뜰폰</option>
                </select>

                <span class="field-group-space"></span>

                <select
                        name="trno_selectbox"
                        class="input-width-xxsmall"
                        title="지역번호선택"
                        v-model="registration.moveInfo.titleHolder.phonNo_trno"
                        id="id_titleholder_phonNo_trno"
                        disabled
                >
                  <option value="010"> 010 </option><option value="011"> 011 </option><option value="016"> 016 </option><option value="017"> 017 </option>
                  <option value="018"> 018 </option><option value="019"> 019 </option><option value="0505"> 0505 </option><option value="0506"> 0506 </option>
                  <option value="0130"> 0130 </option><option value="0303"> 0303 </option><option value="0502"> 0502 </option>
                </select>

                <input
                        id="id_titleholder_authTlno_txno"
                        type="text"
                        maxlength="4"
                        @input="onlyNumber"
                        name="nm_atitleholder_phonNo_txNo"
                        v-model="registration.moveInfo.titleHolder.phonNo_txno"
                        autocomplete="off"
                        class="input-text input-font input-width-xxsmall input-text-disabled"
                        title="일반전화 입력"
                        ref="ref_phonNo"
                        disabled
                />
                -
                <input
                        id="id_titleholder_authTlno_tsno"
                        type="text"
                        maxlength="4"
                        @input="onlyNumber"
                        name="nm_titleholder_phonNo_tsNo"
                        v-model="registration.moveInfo.titleHolder.phonNo_tsno"
                        autocomplete="off"
                        class="input-text input-font input-width-xxsmall input-text-disabled"
                        title="일반전화 입력"
                        ref="ref_phonNo"
                        disabled
                />
<!--                <input-->
<!--                  id="phonNo_forMove"-->
<!--                  type="text"-->
<!--                  maxlength="12"-->
<!--                  @input="onlyNumber"-->
<!--                  name="phonNoforMove"-->
<!--                  v-model="registration.moveInfo.titleHolder.phonNo"-->
<!--                  class="input-text input-font input-text-disabled"-->
<!--                  placeholder="'-' 없이 숫자만 입력"-->
<!--                  title="명의인 이동전화 입력"-->
<!--                  ref="ref_phonNo"-->
<!--                  disabled=true-->
<!--                />-->

              </dd>
            </dl>


            <dl class="field-group">
              <dt class="field-label">
                명의인 입력정보
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <select
                    id="titleHolderInfoYear"
                    name="sel_titleHolderInfoYear"
                    class="input-width-xxsmall"
                    v-model="registration.moveInfo.titleHolder.info.year"
                  >
                    <option
                      v-for="year in yearList"
                      :value="year"
                      :key="year"
                      >{{ year }}</option
                    >

                  </select>
                  년
                  <select
                    id="titleHolderInfoMonth"
                    name="sel_titleHolderInfoMonth"
                    class="input-width-xxsmall"
                    v-model="registration.moveInfo.titleHolder.info.month"
                  >
                    <option value="01"> 01 </option><option value="02"> 02 </option><option value="03"> 03 </option><option value="04"> 04 </option>
                    <option value="05"> 05 </option><option value="06"> 06 </option><option value="07"> 07 </option><option value="08"> 08 </option>
                    <option value="09"> 09 </option><option value="10"> 10 </option><option value="11"> 11 </option><option value="12"> 12 </option>
                  </select>
                  월
                  
                  <select
                    id="titleHolderInfoDate"
                    name="sel_titleHolderInfoDate"
                    class="input-width-xxsmall"
                    v-model="registration.moveInfo.titleHolder.info.date"
                  >
                    <option value="01"> 01 </option><option value="02"> 02 </option><option value="03"> 03 </option><option value="04"> 04 </option>
                    <option value="05"> 05 </option><option value="06"> 06 </option><option value="07"> 07 </option><option value="08"> 08 </option>
                    <option value="09"> 09 </option><option value="10"> 10 </option><option value="11"> 11 </option><option value="12"> 12 </option>
                    <option value="13"> 13 </option><option value="14"> 14 </option><option value="15"> 15 </option><option value="16"> 16 </option>
                    <option value="17"> 17 </option><option value="18"> 18 </option><option value="19"> 19 </option><option value="20"> 20 </option>
                    <option value="21"> 21 </option><option value="22"> 22 </option><option value="23"> 23 </option><option value="24"> 24 </option>
                    <option value="25"> 25 </option><option value="26"> 26 </option><option value="27"> 27 </option><option value="28"> 28 </option>
                    <option value="29"> 29 </option><option value="30"> 30 </option><option value="31"> 31 </option>
                  </select>
                  일

                  <div class="field-control-sub">
                    <div
                      id="radio_sex_male_forMove"
                      class="input-container input-horizontal"
                    >
                      <input
                        id="sex_male_forMove"
                        type="radio"
                        name="sex_forMove"
                        value="M"
                        class="input-radio"
                        title="남성"
                        ref="sex_male_forMove"
                        v-model="registration.moveInfo.titleHolder.info.sex"
                      />
                      <label
                        for="sex_male_forMove"
                        class="input-label"
                        >남</label
                      >
                    </div>
                    <div
                      id="radio_sex_female_forMove"
                      class="input-container input-horizontal"
                    >
                      <input
                        id="sex_female_forMove"
                        type="radio"
                        name="sex_forMove"
                        value="F"
                        class="input-radio"
                        v-model="registration.moveInfo.titleHolder.info.sex"
                        title="여성"
                      />
                      <label for="sex_female_forMove" class="input-label"
                        >여</label
                      >
                    </div>
                    


                    <div
                      id="radio_local_foreigner_forMove"
                      class="input-container input-horizontal"
                    >
                      <input
                        id="radio_local_forMove"
                        type="radio"
                        name="local_foreigner_forMove"
                        value="L"
                        class="input-radio"
                        title="내국인"
                        v-model="registration.moveInfo.titleHolder.info.isDomestic"
                      />
                      <label
                        for="radio_local_forMove"
                        class="input-label"
                        >내국인</label
                      >
                    </div>
                    <div
                      id="radio_local_foreigner_forMove"
                      class="input-container input-horizontal"
                    >
                      <input
                        id="radio_foreigner_forMove"
                        type="radio"
                        name="local_foreigner_forMove"
                        value="F"
                        class="input-radio"
                        title="외국인"
                        v-model="registration.moveInfo.titleHolder.info.isDomestic"
                      />
                      <label for="radio_foreigner_forMove" class="input-label"
                        >외국인</label
                      >
                    </div>
                  </div>   
                </div>
              </dd>
            </dl>

           

            <dl class="field-group">
              <dt class="field-label">
                청구계약정보
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                <select
                  id="contractInfo"
                  name="sel_contractInfo"
                  class="input-width-xsmall"
                  v-model="registration.moveInfo.contractInfoCode"
                  @change="chgContractInfo"
                >
                  <option
                    title="선택해주세요"
                    value=""
                  >
                  선택해주세요
                  </option>
                  <option
                    title="은행계좌번호"
                    value="1"
                  >
                  은행계좌번호
                  </option>
                  <option
                    title="신용카드번호"
                    value="2"
                  >
                  신용카드번호
                  </option>
                  <option
                    title="합산청구번호"
                    value="3"
                  >
                  합산청구번호
                  </option>
                  <option
                    title="OCR(지로)"
                    value="4"
                  >
                  OCR(지로)
                  </option>
                </select>

                <span class="field-group-space"></span>
                청구계약정보
                <span class="field-group-space"></span>

                <input
                  type="text"
                  @input="onlyText"
                  ref="ref_contractInfo"
                  name="input_contractInfo"
                  v-model="registration.moveInfo.contractInfoDetail"
                  class="input-text input-width-small input-font"
                  title="청구계약정보 입력"
                  maxlength="4"
                />
                </div>

                <ul class="notice-text-list">
                  <li class="notice-text">
                    청구계약 정보는 각 코드에 해당되는 마지막 뒷네자리를 입력하면 됩니다. 
                  </li>
                </ul>
                
              </dd>
            </dl>


            <dl class="field-group">
              <dt class="field-label">
                필수 안내사항
              </dt>
              <dd class="field-control">
                  <div class="field-control-sub" v-if="this.registration.moveInfo.fnpPrevEnprInfo.prevEnpr === '1'">
                    <div
                      id="id_nmpt_instlCostRfndTypN"
                      class="input-container input-horizontal"
                    >
                      <input
                        id="nmpt_instlCostRfndTypN"
                        type="radio"
                        name="nmpt_instlCostRfndTypN"
                        value="N"
                        class="input-radio"
                        title="설비비 없음"
                        v-model="registration.moveInfo.instlCostRfndYn"
                      />
                      <label
                        for="nmpt_instlCostRfndTypN"
                        class="input-label"
                        >설비비 없음</label
                      >
                    </div>
                    <div
                      id="id_nmpt_instlCostRfndTypY"
                      class="input-container input-horizontal"
                    >
                      <input
                        id="nmpt_instlCostRfndTypY"
                        type="radio"
                        name="instlCostRfndYn"
                        value="Y"
                        class="input-radio"
                        v-model="registration.moveInfo.instlCostRfndYn"
                        title="계좌이체"
                      />
                      <label for="nmpt_instlCostRfndTypY" class="input-label"
                        >계좌이체</label
                      >
                    </div>
                    <div
                      id="id_nmpt_instlCostRfndTypD"
                      class="input-container input-horizontal"
                    >
                      <input
                        id="nmpt_instlCostRfndTypD"
                        type="radio"
                        name="instlCostRfndYn"
                        value="D"
                        class="input-radio"
                        v-model="registration.moveInfo.instlCostRfndYn"
                        title="직접수령"
                      />
                      <label for="nmpt_instlCostRfndTypD" class="input-label"
                        >직접수령</label
                      >
                    </div>
                    
                    <div class="field-control-sub" v-if="registration.moveInfo.instlCostRfndYn === 'Y'">
                  
                      은행명
                      <select
                        id="sel_bankCorp"
                        name="selNm_bankCorp"
                        class="input-width-small"
                        v-model="registration.moveInfo.bankCorp"
                      >
                        <option value=""> 선택해주세요 </option>
                        <option value="099"> 금융결제원</option>
                        <option value="031"> 대구은행</option>
                        <option value="050"> 상호저축</option>
                        <option value="026"> 신한은행</option>
                        <option value="071"> 우체국</option>
                        <option value="005"> 외환은행</option>
                        <option value="020"> 우리은행</option>
                        <option value="048"> 신용협동조합</option>
                        <option value="058"> 다이이찌은행</option>
                        <option value="057"> 상와은행</option>
                        <option value="059"> 도쿄미쯔</option>
                        <option value="025"> 서울은행</option>
                        <option value="039"> 경남은행</option>
                        <option value="003"> 기업은행</option>
                        <option value="004"> 국민은행</option>
                        <option value="007"> 수협중앙회</option>
                        <option value="011"> 농협중앙회</option>
                        <option value="045"> 새마을금고</option>
                        <option value="034"> 광주은행</option>
                        <option value="012"> 단위농협</option>
                        <option value="037"> 전북은행</option>
                        <option value="021"> 조흥은행</option>
                        <option value="001"> 한국은행</option>
                        <option value="035"> 제주은행</option>
                        <option value="056"> 에이비엔</option>
                        <option value="081"> 하나은행</option>
                        <option value="027"> 씨티은행</option>
                        <option value="055"> 도이치은행</option>
                        <option value="032"> 부산은행</option>
                        <option value="006"> 한국주택은행</option>
                        <option value="002"> 산업은행</option>
                        <option value="053"> 한국씨티은행</option>
                        <option value="023"> 제일은행</option>
                        <option value="054"> 홍콩상하이은행</option>
                        <option value="088"> 신한은행</option>
                        <option value="240"> 삼성증권</option>
                        <option value="243"> 한국투자증권</option>
                        <option value="262"> 하이투자증권</option>
                        <option value="263"> 에이치엠씨투자증권</option>
                        <option value="267"> 대신증권</option>
                        <option value="269"> 한화증권</option>
                        <option value="270"> 하나대투증권</option>
                        <option value="278"> 신한금융투자</option>
                        <option value="279"> 동부증권</option>
                        <option value="280"> 유진투자증권</option>
                        <option value="287"> 메리츠증권</option>
                        <option value="289"> 엔에이치투자증권</option>
                        <option value="290"> 부국증권</option>
                        <option value="291"> 신영증권</option>
                        <option value="008"> 수출입은행</option>
                        <option value="064"> 산림조합</option>
                        <option value="076"> 신용보증기금</option>
                        <option value="077"> 기술신보</option>
                        <option value="060"> Bank Of America</option>
                        <option value="209"> 동양종합금융증권</option>
                        <option value="218"> 현대증권</option>
                        <option value="230"> 미래에셋증권</option>
                        <option value="238"> 대우증권</option>
                        <option value="247"> 우리투자증권</option>
                        <option value="266"> 에스케이증권</option>
                      </select>
                      <span class="field-group-space"></span>
                      계좌번호
                      <input
                        type="text"
                        @input="onlyNumber"
                        ref="ref_bankDetail"
                        name="input_bankDetail"
                        v-model="registration.moveInfo.bankDetail"
                        class="input-text input-width-small input-font"
                        title="은행계좌번호 입력"
                        placeholder="'-' 없이 숫자만 입력"
                      />
                    </div>
                  </div>
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
              
              </dt>
              <dd class="field-control">
                
                <ul class="notice-text-list">
                  <div v-if="this.registration.moveInfo.fnpPrevEnprInfo.prevEnpr === '1'">
                   <li class="notice-text">
                        설비비 반환이란? 
                      </li>
                      <li class="notice-text">
                        KT시내전화 설비비형 가입자가 번호이동으로 기존 전화가 해지되는 경우 가입시 예치한 설비비를 환급 받을 수 있는 제도
                      </li>
                      <li class="notice-text">
                        KT설비비형 확인방법 : ① KT 고객센터 문의(☎100번) ② 기본료 3,700원인 경우 
                      </li>
                  </div>

                  <li class="notice-text">
                    번호이동 후 6개월간은 재이동이 불가합니다 .
                  </li>
                  <li class="notice-text">
                    번호이동시 현재 사용중인 연관상품은 자동 분리 또는 해지됩니다. 일부 연관상품은 번호이동관리센터에서
                    고객확인후 처리되며, 결합상품이 있는 경우 결합할인 혜택 축소와 위약금이 발생할 수 있습니다. 
                  <li class="notice-text">
                    현재 사용중인 KT 전화가 설비비형인 경우 가입자에게 설비비가 반환됩니다. 
                  </li>
                  <li class="notice-text">
                    번호이동 후 시내전화 통화권을 준수하여야 하며, 통화권 이탈시 번호이동 서비스가 제한됩니다. 
                  <li class="notice-text">
                    인터넷전화는 정전시 통화가 불가하며, 긴급통신은 변경 주소 미신고시 긴급통신이 제한되오니, 변경 주소가
                    있는 경우 반드시 신고해야 합니다. 
                  </li>
                </ul>
                <div class="field-control-sub">
                  <div
                    id=""
                    class="input-container"
                  >
                    <input
                      id="agreeForMove"
                      type="checkbox"
                      name="sel"
                      class="input-checkbox input-text"
                      ref=""
                      value=true
                      v-model="isMoveCheck"
                    />
                    <label
                      for="agreeForMove"
                      class="input-label"
                      >상기내용을 확인하였습니다.</label
                    >
                  </div>
                </div>
              </dd>
            </dl>

          </div>
        </div>
      </div>
    </div>


    <div class="registration-page">
      <div class="registration-page-container">
        <div class="step-bottom-area input-wrap">
          <button
            class="primary-button mw100 pc-float-right"
            @click="save"
          >
            저장 후 다음으로 이동
          </button>
        </div>
      </div>
    </div>

    <v-dialog />
  </div>
</template>

<script>
import ZipcodeDirectPopup from '../popup/ZipcodeDirectPopup'
import SearchDealerPopup from '../popup/SearchDealerPopup'
import { getBlEmailBlock } from '@/api/captureService'
import { getAreaNoBtZpcd,getFnpPrevEnpr,getFpnRqstPsblYn,getHmCntcInfo,getMacInfo, getIpAddress} from '@/api/onsaleHome'
import myCaptcha from 'vue-captcha'
import {  callKMCAuthPopup,callIpinPopupTPS,smsAuthSendTPS,smsAuthCheckTPS ,getTpsAutnInfo} from '@/api/common'
import { routerHome } from '@/router/routerHome'

export default {
  name: 'OnsaleHomeStep1',

  data() {
    return {
      estbAllAddr:'',//설치주소
      estbProdNm:'',//상품명
      estbSbcContNo:'',//상품추가
      estbCnvgNo:'',//상품추가
      isNew:(this.$route.params.isExist)? false : true,//신규인지 기존신청서인지
      homeCntnFlag:false,//홈계약여부 유무

      tmpCustNm:'',//LG u+고객인 경우 인증 시 사용
      tmpCustrnmBday:'',//LG u+고객인 경우 인증 시 사용
      tmpIpinCi:'',//LG u+고객인 경우 인증 시 사용
      tmpPhonNo:'',//LG u+고객인 경우 인증 시 사용
      isMoveCheck:false,
      appfData:{},
      ipAddr:'',
      macAddr:'',//mac address
      isAuth:false,//인증유무
      showAuthTab:false,//인증번호탭 노출 여부
      authCd:'',//인증 수단 KMC or IPIN or SMS(LG U+)
      isCaptcha: false,//SMS 전송 시 보안문자 통과해야 KMC 인증
      authNo:'',//인증번호
      agreement:{
        personalInfoEssential:false,//개인정보 수집동의(필수)
        personalInfoOptional:false,//개인정보 수집동의(선택)
       // personalInfoEntrust:false,//개인정보 취급 위탁동의서  개인정보 compliance 점검결과적용 2025.02.12
      },
      kmcInfo:{

      },

      yearList:[ ],
      chkEmailAgree:false,
      selectedEmailDomain:'',

      service:{
        isHome:true,//true-> home /false -> soho
        chkInternet:true,
        chkInternetPhone:false,
        moveYn:false,
        line_cnt:'',//회선수 --> 소호일 경우
        chkTV:false,
        chkIoT:false,
        chkExclusive:false,
        chkTrue:true,//단독맘카(항상 true)
      },

      registration:{
        homeCntnInfo:[],
        homeCntnStatus:{},//홈계약정보 선택
        dealerInfo:'',
        dealer:{
          oRes:'',
          oMsg:'',
          selrId:'',
          selrTyp:'',
          tmpAplyTyp:'',
          csalesCd:'',
          rmk:'',
          selTyp:'',
          selPathCd:'',
          selChnlTyp:'',
          zipCd:'',
          allAddr:'',
          telNo:'',
          email:'',
          dlrCd:'',
          dlrGrpCd:'',
          spare1:'',//ID
          spare2:'',//name
          _rowStatus:'',
          posCd:'', //대리점에 속한 Pos코드(add_20201021_posCd)
        },

        name:'',
        birthYear:new Date().getFullYear().toString(),
        birthMonth:'01',
        birthDate:'01',
        sex:'M',
        isDomestic:'L',

        phonNo:'',//인증용 이동전화
        phonNo_trno:'',
        phonNo_txno:'',
        phonNo_tsno:'',
        phonCorp:'',//인증용 이동통신사
        
        crplZpcd:'',
        crplAddr:'',
        crplDadr:'',
        addr1:'',
        addr2:'',
        roadAddr1:'',
        roadAddr2:'',

        spclDet:'',//기타요청사항

        tlno:'',//일반전화
        tlno_trno:'',
        tlno_txno:'',
        tlno_tsno:'',
        authTlno:'',//인증이동전화
        authTlno_trno:'',
        authTlno_txno:'',
        authTlno_tsno:'',

        
        emailId:'',
        emailDomain:'',
        email:'',

        moveInfo:{//번호이동 신청정보
          ischeck:false,//번호이동확인버튼 클릭
          fnpPrevEnprInfo:{

          },
          areaNoBtZpcdInfo1:{

          },
          areaNoBtZpcdInfo2:{

          },
          fpnRqstPsblYnInfo:{
            entrNo:'',
            mnpPrgrsSttsDvCd:'',
            mnpTrdtPrssDvCd:'',
            rlopnSucsDvCd:'',
          },
          trno:'',
          txno:'',
          tsno:'',
          moveTlno:'',//번호이동 전화번호
          beforeBuisness:'',//변경전사업자
          instlCostRfndYn:'N',//설치비반환방법

          bankCorp:'',//은행명
          bankDetail:'',//은행계좌번호

          titleHolder:{
            name:'',//명의인 이름
            tlno:'',//명의인 일반전화
            tlno_trno:'',
            tlno_txno:'',
            tlno_tsno:'',
            phonNo:'',//명의인 이동전화
            phonNo_trno:'',
            phonNo_txno:'',
            phonNo_tsno:'',
            phonCorp:'',//명의인 이동통신사
            
            info:{//명의인 입력정보
              year:new Date().getFullYear(),
              month:'01',
              date:'01',
              sex:'M',//남 or 여
              isDomestic:'L',//내국인 or 외국인
            },
          },
          
          contractInfoCode:'',//청구계약정보
          contractInfoDetail:'',//청구계약정보 코드 네자리
        },
      },
      emailDomainList:[
        {domainNm : '네이버', domainDetail:'naver.com'},
        {domainNm : '다음(한메일)', domainDetail:'daum.net'},
        {domainNm : '지메일', domainDetail:'gmail.com'},
        {domainNm : '핫메일', domainDetail:'hotmail.com'},
      ],
    }
  },

  components: {
    ZipcodeDirectPopup,
    SearchDealerPopup,
    'my-captcha': myCaptcha
  },

  mounted() {
    let currentYear = new Date().getFullYear()
    for(let i=currentYear; i>=1912; i--) {
        let date = i
        this.yearList.push(date.toString())
    }
    this.getSelrId()
    this.getMacAddress()
    this.getIpAddr()
  },

  methods: {
    getIpAddr(){
      getIpAddress()
          .then(res => {
            let tmp = res.data
            this.ipAddr = tmp.ip
          })
          .catch(e => {
          })
    },

    getSelrId(){
      if(!this.$route.query.selrId) return
      if(this.$route.query.selrId !== ''){
        this.searchDealerPopup()
      }
    },

    captchaOk () {
      this.isCaptcha = true
    },


    onlyNumber(e) {
      if(e.target.name === 'authTlno') this.registration.authTlno = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'tlno') this.registration.tlno = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'input_bankDetail') this.registration.moveInfo.bankDetail = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'authNo') this.registration.authNo = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'phonNo') this.registration.phonNo = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'phonNoforMove') this.registration.moveInfo.titleHolder.phonNo = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'nm_txNo_phonNo') this.registration.phonNo_txno = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'nm_tsNo_phonNo') this.registration.phonNo_tsno = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'nm_tsNo_forMove') this.registration.moveInfo.tsno = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'nm_txNo_forMove') this.registration.moveInfo.txno = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'nm_line_cnt') this.service.line_cnt = e.target.value.replace(/[^0-9]/gi, '')
    },

    onlyText(e) {
      if(e.target.name === 'name') this.registration.name = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
      if(e.target.name === 'input_contractInfo') this.registration.moveInfo.contractInfoDetail = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
      if(e.target.name === 'emailId') this.registration.emailId = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
    },
    
    openIPIN(){
      if(!this.beforeAuth()){
        this.openAlert('온라인 가입신청 안내', '먼저 개인정보 수집에 동의해주시기 바랍니다.')
        return
      }
      if(this.registration.name === ''){
        this.openAlert('온라인 가입신청 안내', '성명을 입력해주시기 바랍니다.')
        return
      }
      callIpinPopupTPS().then(res => {
        let splitRes = res.split(',')
        let custInfo = {
          name: splitRes[0],
          phoneNo: '',
          birthDay: splitRes[1],
          ipinCi:splitRes[2],
          custNationalCd:splitRes[3],
          genderCode:splitRes[4]
        }
        this.authCd = 'IPIN'
        if(this.registration.name === custInfo.name && (this.registration.birthYear.substr(2,2) + this.registration.birthMonth + this.registration.birthDate) === custInfo.birthDay){
          this.isAuth = true

          this.appfData.moct_birthDay=custInfo.birthDay//인증 생년월일 ex)940126--> 인증 단계에서 적용
          this.appfData.moct_name=custInfo.name//인증 이름--> 인증 단계에서 적용
          this.appfData.moct_phoneNo=''//인증휴대폰번호--> 인증 단계에서 적용
          this.appfData.ipinCi=custInfo.ipinCi//ipinCi --> 인증 단계에서 적용


          if(!this.isNew){//기존신청서일 경우
            this.getHomeInfo()
          }
          else{//신규
          // ST 내외국인 확인 추가 2024.10.25
          if (this.registration.isDomestic !== (custInfo.custNationalCd==="0" ?"L":"F")||
           this.registration.sex!==(custInfo.genderCode==="0" ?"F":"M")){
              this.failAuth()
           }else{
           // ED 내외국인 확인 추가 2024.10.25 
            this.openAlert('온라인 가입신청 안내', '본인 인증에 성공하였습니다.')
           }
          }
        }
        else{
          this.authCd = 'IPIN'
          this.failAuth()
        }
      }).catch(error => {
        this.openAlert('온라인 가입신청 안내', '본인인증 도중 문제가 발생하였습니다.\n다시 시도해주시기 바랍니다.')
      })

    },

    failAuth(){//인증 실패
      this.openAlert('온라인 가입신청 안내', '가입자 정보와 본인 인증 정보가 일치하지 않습니다. 다시 시도 바랍니다.')
      this.appfData.moct_birthDay=''//인증 생년월일 ex)940126--> 인증 단계에서 적용
      this.appfData.moct_name=''//인증 이름--> 인증 단계에서 적용
      this.appfData.moct_phoneNo=''//인증휴대폰번호--> 인증 단계에서 적용
      this.appfData.ipinCi=''//ipinCi --> 인증 단계에서 적용
      this.isAuth = false
    },

    getHomeInfo(){//기존신청서일 경우 --> 인증 정보로 홈 계약정보 가져오기
      getHmCntcInfo(this.appfData.ipinCi,'','C').then(res => {
        let resultCd = res.data.dsRsltInfo.rsltCd
        let resultMsg = res.data.dsRsltInfo.rsltMsg
        if (resultCd === 'SUCCESS') {
          //홈 계약 정보가 없는 경우
          if(res.data.dsOutput.length === 0){
            alert('서비스를 신청한 내역이 없습니다. 확인 후 신청바랍니다.')
            routerHome.push({ name: 'OnsaleHome' })
          }
          else{
            //홈계약정보가 있는 경우
            //1. homeCntnFlag 홈계약여부 true
            this.homeCntnFlag = true
            let idx = 0
            for(let i = 0 ; i < res.data.dsOutput.length ; i++){
              if(i === 0){
                let tmpData = {}
                tmpData.cnvgNo = res.data.dsOutput[i].cnvgNo
                tmpData.prodNm = res.data.dsOutput[i].prodNm
                tmpData.cnvgKdCd = res.data.dsOutput[i].cnvgKdCd
                tmpData.taskYn = res.data.dsOutput[i].taskYn
                tmpData.cnvgKdNm = res.data.dsOutput[i].cnvgKdNm
                tmpData.custNo = res.data.dsOutput[i].custNo
                tmpData.emailAddr = res.data.dsOutput[i].emailAddr
                tmpData.entrSttsCd = res.data.dsOutput[i].entrSttsCd
                tmpData.estbAddrNo = res.data.dsOutput[i].estbAddrNo
                tmpData.estbAllAddr = res.data.dsOutput[i].estbAllAddr
                tmpData.estbAdminDcd = res.data.dsOutput[i].estbAdminDcd
                tmpData.estbAptDaddre = res.data.dsOutput[i].estbAptDaddre
                tmpData.estbAptHoaddr = res.data.dsOutput[i].estbAptHoaddr
                tmpData.estbBldnNm = res.data.dsOutput[i].estbBldnNm
                tmpData.estbCcwNm = res.data.dsOutput[i].estbCcwNm
                tmpData.estbCdonm = res.data.dsOutput[i].estbCdonm
                tmpData.estbHelpAddr = res.data.dsOutput[i].estbHelpAddr
                tmpData.estbHoaddr = res.data.dsOutput[i].estbHoaddr
                tmpData.estbHsnmbAddr = res.data.dsOutput[i].estbHsnmbAddr
                tmpData.estbIslnNm = res.data.dsOutput[i].estbIslnNm
                tmpData.estbLawcDcd = res.data.dsOutput[i].estbLawcDcd
                tmpData.estbLcatDvCd = res.data.dsOutput[i].estbLcatDvCd
                tmpData.estbRinm = res.data.dsOutput[i].estbRinm
                tmpData.estbRsdcFormCd = res.data.dsOutput[i].estbRsdcFormCd
                tmpData.estbTownNm = res.data.dsOutput[i].estbTownNm
                tmpData.estbZip = res.data.dsOutput[i].estbZip
                tmpData.prodCd = res.data.dsOutput[i].prodCd
                tmpData.contStrtYmd = res.data.dsOutput[i].contStrtYmd
                tmpData.sbcContNo = res.data.dsOutput[i].entrNo
                tmpData.svcVoipYn = ''
                tmpData.svcIptvVodYn = ''
                tmpData.svcXpeedYn = ''
                tmpData.svcIptvYn = ''
                if(res.data.dsOutput[i].voipYn === 'Y'){
                  tmpData.svcVoipYn = 'Y'
                }
                if(res.data.dsOutput[i].vodYn === 'Y'){
                  tmpData.svcIptvVodYn = 'Y'
                }
                if(res.data.dsOutput[i].xpdYn === 'Y'){
                  tmpData.svcXpeedYn = 'Y'
                }
                if(res.data.dsOutput[i].iptvYn === 'Y'){
                  tmpData.svcIptvYn = 'Y'
                }
                this.registration.homeCntnInfo[idx] = tmpData
              }
              else{
                //이전 idx와 같은 cnvgNo인지 확인 후 같으면
                if(res.data.dsOutput[i].cnvgNo === this.registration.homeCntnInfo[idx].cnvgNo && res.data.dsOutput[i].cnvgNo !== ''){
                  this.registration.homeCntnInfo[idx].prodNm += ', ' + res.data.dsOutput[i].prodNm
                  if(res.data.dsOutput[i].voipYn === 'Y'){
                    this.registration.homeCntnInfo[idx].svcVoipYn = 'Y'
                  }
                  if(res.data.dsOutput[i].vodYn === 'Y'){
                    this.registration.homeCntnInfo[idx].svcIptvVodYn = 'Y'
                  }
                  if(res.data.dsOutput[i].xpdYn === 'Y'){
                    this.registration.homeCntnInfo[idx].svcXpeedYn = 'Y'
                  }
                  if(res.data.dsOutput[i].iptvYn === 'Y'){
                    this.registration.homeCntnInfo[idx].svcIptvYn = 'Y'
                  }
                }
                else{//다르면
                  idx++
                  let tmpData = {}
                  tmpData.cnvgNo = res.data.dsOutput[i].cnvgNo
                  tmpData.prodNm = res.data.dsOutput[i].prodNm
                  tmpData.cnvgKdCd = res.data.dsOutput[i].cnvgKdCd
                  tmpData.taskYn = res.data.dsOutput[i].taskYn
                  tmpData.cnvgKdNm = res.data.dsOutput[i].cnvgKdNm
                  tmpData.custNo = res.data.dsOutput[i].custNo
                  tmpData.emailAddr = res.data.dsOutput[i].emailAddr
                  tmpData.entrSttsCd = res.data.dsOutput[i].entrSttsCd
                  tmpData.estbAllAddr = res.data.dsOutput[i].estbAllAddr
                  tmpData.estbAddrNo = res.data.dsOutput[i].estbAddrNo
                  tmpData.estbAdminDcd = res.data.dsOutput[i].estbAdminDcd
                  tmpData.estbAptDaddre = res.data.dsOutput[i].estbAptDaddre
                  tmpData.estbAptHoaddr = res.data.dsOutput[i].estbAptHoaddr
                  tmpData.estbBldnNm = res.data.dsOutput[i].estbBldnNm
                  tmpData.estbCcwNm = res.data.dsOutput[i].estbCcwNm
                  tmpData.estbCdonm = res.data.dsOutput[i].estbCdonm
                  tmpData.estbHelpAddr = res.data.dsOutput[i].estbHelpAddr
                  tmpData.estbHoaddr = res.data.dsOutput[i].estbHoaddr
                  tmpData.estbHsnmbAddr = res.data.dsOutput[i].estbHsnmbAddr
                  tmpData.estbIslnNm = res.data.dsOutput[i].estbIslnNm
                  tmpData.estbLawcDcd = res.data.dsOutput[i].estbLawcDcd
                  tmpData.estbLcatDvCd = res.data.dsOutput[i].estbLcatDvCd
                  tmpData.estbRinm = res.data.dsOutput[i].estbRinm
                  tmpData.estbRsdcFormCd = res.data.dsOutput[i].estbRsdcFormCd
                  tmpData.estbTownNm = res.data.dsOutput[i].estbTownNm
                  tmpData.estbZip = res.data.dsOutput[i].estbZip
                  tmpData.prodCd = res.data.dsOutput[i].prodCd
                  tmpData.contStrtYmd = res.data.dsOutput[i].contStrtYmd
                  tmpData.sbcContNo = res.data.dsOutput[i].entrNo
                  tmpData.svcVoipYn = ''
                  tmpData.svcIptvVodYn = ''
                  tmpData.svcXpeedYn = ''
                  tmpData.svcIptvYn = ''
                  if(res.data.dsOutput[i].voipYn === 'Y'){
                    tmpData.svcVoipYn = 'Y'
                  }
                  if(res.data.dsOutput[i].vodYn === 'Y'){
                    tmpData.svcIptvVodYn = 'Y'
                  }
                  if(res.data.dsOutput[i].xpdYn === 'Y'){
                    tmpData.svcXpeedYn = 'Y'
                  }
                  if(res.data.dsOutput[i].iptvYn === 'Y'){
                    tmpData.svcIptvYn = 'Y'
                  }
                  this.registration.homeCntnInfo[idx] = tmpData
                }
              }

            }
            for(let i = 0; i< this.registration.homeCntnInfo.length;i++){
              //disable여부와 tmpComment설정
              if(this.registration.homeCntnInfo[i].taskYn === 'N'){
                this.registration.homeCntnInfo[i].isDisable = true
                this.registration.homeCntnInfo[i].tmpComment = '현재 처리중인 서비스변경사항이 존재합니다. 고객센터를 통해서 문의바랍니다. ( 1644-7000 )'
              }

              if(this.registration.homeCntnInfo[i].cnvgKdCd === 'LGZ0000003'){
                this.registration.homeCntnInfo[i].isDisable = true
                this.registration.homeCntnInfo[i].tmpComment = this.registration.homeCntnInfo[i].cnvgKdNm
              }

              if(this.registration.homeCntnInfo[i].cnvgKdCd === 'LGZ0000002'){
                this.registration.homeCntnInfo[i].tmpComment = this.registration.homeCntnInfo[i].cnvgKdNm
              }

              if(this.registration.homeCntnInfo[i].cnvgKdCd !== 'LGZ0000002' &&
                    this.registration.homeCntnInfo[i].cnvgKdCd !== 'LGZ0000003' &&
                    this.registration.homeCntnInfo[i].svcVoipYn === 'Y'){
                this.registration.homeCntnInfo[i].isDisable = true
                this.registration.homeCntnInfo[i].tmpComment = '070단독 상품입니다.'
              }
            }

            let tmpFlag = false //신청가능한 상품정보가 있는지 확인

            for(let i = 0; i< this.registration.homeCntnInfo.length;i++){
              if(typeof this.registration.homeCntnInfo[i].isDisable === 'undefined' || !this.registration.homeCntnInfo[i].isDisable){
                tmpFlag = true
                break
              }
            }
            if(tmpFlag){
              this.openAlert('온라인 가입신청 안내', '본인 인증에 성공하였습니다.')
            }
            else{
              alert('신청 가능한 기존 상품이 없습니다.')
              routerHome.push({ name: 'OnsaleHome' })
            }

          }
        } else {
          //에러
          alert('신청 중 오류가 발생했습니다. 잠시 후 다시 시도 바랍니다.')
          routerHome.push({ name: 'OnsaleHome' })
        }
      })
      .catch(e => {
        this.openAlert('에러', e.message)
      })
    },
    
    validateAuthNo(){
      //SMS인증 성공사례
      // let title = '휴대폰인증'
      // let param = {
      //   phoneNo: '01035707637',
      //   dealCd: '123456',
      //   onetMblAppfNo: '',
      //   lgdBuyer: '염창보',
      //   lgdPrivateno: '940126',
      //   smsval: '999999'        
      // }
      // smsAuthCheck(param).then(res => {
      //   let resultCd = res.data.dsRes.msgCd
      //   let resultMsg = res.data.dsRes.msg
      //   if (resultCd === 'SUCCESS') {
      //     this.openAlert(title, resultMsg)
      //   } else {
      //     this.openAlert(title, resultMsg)
      //   }
      // })


      let title = '휴대폰인증'
      let param = {
        phoneNo: this.registration.phonNo_trno + this.registration.phonNo_txno + this.registration.phonNo_tsno,
        dealCd:  this.registration.dealer.dlrCd,
        onetMblAppfNo: '',
        lgdBuyer: this.registration.name,
        lgdPrivateno: this.registration.birthYear.substr(2,2) + this.registration.birthMonth + this.registration.birthDate,
        smsval: this.authNo,
        isDomestic:this.registration.isDomestic,
        sex: this.registration.sex
      }
      smsAuthCheckTPS(param).then(res => {
        let resultCd = res.data.dsRsltInfo.rsltCd
        let resultMsg = res.data.dsRsltInfo.rsltMsg
        let resultData = res.data.resultData /*  보안 점검 조치 처리 2023.06.20* 장희정*/
        if (resultCd === 'SUCCESS') {
          this.isAuth = true
          this.registration.authTlno = this.registration.phonNo_trno + this.registration.phonNo_txno + this.registration.phonNo_tsno
          this.registration.authTlno_trno = this.registration.phonNo_trno
          this.registration.authTlno_txno = this.registration.phonNo_txno
          this.registration.authTlno_tsno = this.registration.phonNo_tsno

          //인증정보 저장
          this.appfData.ipinCi = resultData.ipinCi /*  보안 점검 조치 처리 2023.06.20* 장희정*/
          this.appfData.moct_birthDay = resultData.custrnmBday /*  보안 점검 조치 처리 2023.06.20* 장희정*/
          this.appfData.moct_name = resultData.custNm /*  보안 점검 조치 처리 2023.06.20* 장희정*/
          this.appfData.moct_phoneNo = this.registration.authTlno /*  보안 점검 조치 처리 2023.06.20* 장희정*/

          if(!this.isNew){//기존신청서일 경우
            this.getHomeInfo()
          }
          else{//신규
            this.openAlert('온라인 가입신청 안내', '본인 인증에 성공하였습니다.')
            }
        } else {
          this.openAlert(title, resultMsg)
          this.isAuth = false
        }
      })
    },


    sendSMS(){
      //SMS 성공사례
      // let param = {
      //   phoneNo: '01035707637',
      //   dealCd: '123456',
      //   onetMblAppfNo: '',
      //   lgdBuyer: '염창보',
      //   lgdPrivateno: '940126'
      // }
      // smsAuthSend(param)
      //   .then(res => {
      //     let resultCd = res.data.dsRes.msgCd
      //     let resultMsg = res.data.dsRes.msg
      //     if (resultCd === 'SUCCESS') {
      //       this.openAlert('성공', resultMsg)
      //     } else {
      //       this.openAlert(resultCd, resultMsg)
      //     }
      //   })
      //   .catch(e => {
      //     this.openAlert('에러', e.message)
      //   })

      let param = {
        phoneNo: this.registration.phonNo_trno + this.registration.phonNo_txno + this.registration.phonNo_tsno,
        dealCd: this.registration.dealer.dlrCd,
        onetMblAppfNo: '',
        lgdBuyer: this.registration.name,
        lgdPrivateno: this.registration.birthYear.substr(2,2) + this.registration.birthMonth + this.registration.birthDate
      }
      smsAuthSendTPS(param)
        .then(res => {
          let resultCd = res.data.dsRsltInfo.rsltCd
          let resultMsg = res.data.dsRsltInfo.rsltMsg
          if (resultCd === 'SUCCESS') {
            this.openAlert('성공', resultMsg)
            this.showAuthTab = true
            /*  //보안 점검 조치 처리 2023.06.20 장희정
            this.tmpIpinCi = res.data.resultData.ipinCi
            this.tmpCustrnmBday=res.data.resultData.custrnmBday.substr(0,6)//인증 생년월일 ex)940126--> 인증 단계에서 적용
            this.tmpCustNm=res.data.resultData.custNm//인증 이름--> 인증 단계에서 적용
            this.tmpPhonNo=this.registration.phonNo_trno + this.registration.phonNo_txno + this.registration.phonNo_tsno//인증휴대폰번호--> 인증 단계에서 적용
            */
          } else {
            this.openAlert(resultCd, resultMsg)
            this.showAuthTab = false
          }
        })
        .catch(e => {
          this.openAlert('에러', e.message)
        })

     
    },

    beforeAuth(){
     // if(this.agreement.personalInfoEssential && this.agreement.personalInfoEntrust) return true 
     // 개인정보 compliance 점검결과적용 2025.02.12
     if(this.agreement.personalInfoEssential) return true 
      else return false
    },

    clickSMS(){
      if(!this.beforeAuth()){
        this.openAlert('온라인 가입신청 안내', '먼저 개인정보 수집에 동의해주시기 바랍니다.')
        return
      }
      //보안문자, 인증
      this.authCd = 'KMC' //통신사에 따라서 SMS인지 KMC인지 구분 필요
    },

    format4(str){
      let ret = str
      let strLen = str.length
      for(let i = strLen ; i < 4; i++){
        ret += "0"
      }
      return ret
    },

    requestAuth(){
      if(this.registration.name === ''){
        this.openAlert('온라인 가입신청 안내', '이름을 먼저 입력해주시기 바랍니다.')
        return
      }
      if(!this.isCaptcha){
        this.openAlert('온라인 가입신청 안내', '보안문자를 먼저 입력해주시기 바랍니다.')
        return
      }
      if(this.registration.phonCorp === ''){
        this.openAlert('온라인 가입신청 안내', '이동 통신사를 먼저 입력해주시기 바랍니다.')
        return
      }
      if(this.registration.phonNo_trno === '' || this.registration.phonNo_txno === '' || this.registration.phonNo_tsno === ''){
        this.openAlert('온라인 가입신청 안내', '이동 전화를 정확히 입력해주시기 바랍니다.')
        return
      }
      // if(this.registration.phonNo === ''){
      //   this.openAlert('온라인 가입신청 안내', '이동 전화를 먼저 입력해주시기 바랍니다.')
      //   return
      // }
      this.registration.phonNo = this.registration.phonNo_trno + this.registration.phonNo_txno + this.registration.phonNo_tsno

      //통신사에 따라 KMC인지 SMS인지 구분
      if(this.registration.phonCorp === 'LGT' || this.registration.phonCorp === 'LGM'){//LG U+인 경우
      // if(this.registration.phonCorp === 'LGT'){//LG U+인 경우
        this.authCd = 'SMS'
        this.sendSMS()
      }
      else{
        this.authCd = 'KMC'
        this.openKMC()
      }
    },

    /**
     * Function    : checkTeenager
     * Description : 청소년 검사
     **/
    checkTeenager() {
      let date = new Date()
      let year = date.getFullYear().toString()
      year = year.substring(2,4)
      let month = (date.getMonth() + 1)
      let day = date.getDate()
      if(month < 10) month = '0' + month
      if(day < 10) day = '0' + day
      let monthDay = month.toString() + day.toString()
      let birthYY = this.appfData.moct_birthDay.substr(0,2)
      let birthMMDD = this.appfData.moct_birthDay.substr(2,4)
      let tempAge = parseInt(year) - parseInt(birthYY)
      if(tempAge < 0) tempAge = tempAge + 100
      let age = monthDay < birthMMDD ? tempAge - 1 : tempAge
      if(age >= 19) {
        return false
      } else {
        return true
      }
    },

    openKMC(){
      if(!this.beforeAuth()){
        this.openAlert('온라인 가입신청 안내', '먼저 개인정보 수집에 동의해주시기 바랍니다.')
        return
      }
     /* let param = {
        nation:this.registration.isDomestic==="L" ?"O":"1",
        gender: this.registration.sex==="F" ?"1":"0"
      }
      */
      callKMCAuthPopup().then(res => {
        Object.assign(this.kmcInfo, JSON.parse(res))
        if(this.kmcInfo.name === this.registration.name && this.kmcInfo.birthDay === (this.registration.birthYear.substr(2,2) + this.registration.birthMonth + this.registration.birthDate)){
          this.isAuth = true
          this.authCd = 'KMC'

          this.appfData.moct_birthDay=this.kmcInfo.birthDay//인증 생년월일 ex)940126--> 인증 단계에서 적용
          this.appfData.moct_name=this.kmcInfo.name//인증 이름--> 인증 단계에서 적용
          this.appfData.moct_phoneNo=this.kmcInfo.phoneNo//인증휴대폰번호--> 인증 단계에서 적용
          this.appfData.ipinCi=this.kmcInfo.r_Ci//ipinCi --> 인증 단계에서 적용

          //KMC인증 시 인증 전화번호 탭에 전화번호 복사
          this.registration.authTlno = this.registration.phonNo
          this.registration.authTlno_trno = this.registration.phonNo_trno
          this.registration.authTlno_txno = this.registration.phonNo_txno
          this.registration.authTlno_tsno = this.registration.phonNo_tsno
          if(!this.isNew){//기존신청서일 경우
            this.getHomeInfo()
          }
          else{//신규
           // ST 내외국인 확인 추가 2024.10.25
            if ( this.registration.isDomestic !== (this.kmcInfo.r_nation==="0" ?"L":"F")|| // 0 :내국인 1:외국인 내외국인추가
                  this.registration.sex!==(this.kmcInfo.r_gender==="0" ?"M":"F")){//0: 남 1: 여
                  this.failAuth()
             }else{
             // ED 내외국인 확인 추가 2024.10.25
                this.openAlert('온라인 가입신청 안내', '본인 인증에 성공하였습니다.')
            }
          }
        }
        else{
          this.authCd = 'KMC'
          this.failAuth()
        }
      })
    },

    searchDealerPopup(){
      this.$modal.show('searchDealer')
    },

    zipcodeAddressPop(){
      if(this.registration.moveInfo.moveTlno !== '' || this.registration.moveInfo.trno !== '' || this.registration.moveInfo.txno !== '' || this.registration.moveInfo.tsno !== ''){
          if(confirm('설치 주소를 변경하시면 번호이동번호 확인을 다시하셔야 합니다. 진행하시겠습니까?')){
            this.$modal.show('zipcodeAddress')
          }
      }
      else{
        this.$modal.show('zipcodeAddress')
      }
    },

    openAlert(title, message, ref) {
      this.$modal.show('dialog', {
        title: title,
        text: message,
        buttons: [
          {
            title: '확인',
            class: 'primary-button',
            handler: () => {
              this.$modal.hide('dialog')
              if (ref) {
                ref.focus()
              }
            }
          }
        ]
      })
    },



    getMacAddress(){
      // MAC ADDRESS
      let tmp = {}
      getMacInfo()
          .then(res => {
            tmp = res.data
            this.macAddr = tmp.macAddress
          })
          .catch(e => {
          })
    },

    getCorpNm(str){
      let retStr=''
      switch(this.registration.moveInfo.fnpPrevEnprInfo.prevEnpr){
        case 'A009':  retStr = '한국무역정보통신'; break;
        case 'B':  retStr = '한국케이블텔레콤'; break;
        case 'B001':  retStr = '티브로드'; break;
        case 'B002':  retStr = '큐릭스'; break;
        case 'B003':  retStr = 'HCN'; break;
        case 'B004':  retStr = 'CJ헬로비전'; break;
        case 'B005':  retStr = '온미디어'; break;
        case 'B006':  retStr = '서경방송'; break;
        case 'B007':  retStr = 'C&M'; break;
        case 'B008':  retStr = 'GS강남방송'; break;
        case 'B017':  retStr = 'CMB'; break;
        case 'B009':  retStr = '남인천방송'; break;
        case 'B018':  retStr = '영서방송'; break;
        case 'B010':  retStr = '아름방송'; break;
        case 'B019':  retStr = '전북방송'; break;
        case 'B011':  retStr = 'GS울산방송'; break;
        case 'B020':  retStr = '나라방송'; break;
        case 'B012':  retStr = 'HBC호남방송'; break;
        case 'B021':  retStr = '강원방송'; break;
        case 'C':  retStr = '삼성SDS'; break;
        case 'C001':  retStr = 'CV-NET'; break;
        case 'B013':  retStr = '제주방송'; break;
        case 'D':  retStr = '드림라인'; break;
        case 'D001':  retStr = '웹투폰'; break;
        case 'B014':  retStr = '광주방송'; break;
        case 'D002':  retStr = '벤치비'; break;
        case 'E':  retStr = '세종텔레콤'; break;
        case 'B015':  retStr = '새로넷방송'; break;
        case 'F':  retStr = 'KT(인터넷)'; break;
        case 'F001':  retStr = '다이얼커뮤니케이션'; break;
        case 'B016':  retStr = '푸른방송'; break;
        case 'F002':  retStr = '한국인터넷텔레콤'; break;
        case 'F003':  retStr = '게이넷텔'; break;
        case 'F004':  retStr = 'ATI정보통신'; break;
        case 'F005':  retStr = '티메이트'; break;
        case 'F007':  retStr = '케이디넷'; break;
        case 'F008':  retStr = '웹투폰'; break;
        case 'F010':  retStr = '지킴이'; break;
        case 'F011':  retStr = '모음커뮤니케이션'; break;
        case 'F013':  retStr = 'ACO글로벌'; break;
        case 'F014':  retStr = '라이프포럼'; break;
        case 'F015':  retStr = 'KTN'; break;
        case 'F016':  retStr = '디지털멀티텍'; break;
        case 'F017':  retStr = '하이텔레콤'; break;
        case 'F018':  retStr = '에이케이'; break;
        case '1':  retStr = 'KT(시내)'; break;
        case '2':  retStr = 'SK브로드밴드(시내)'; break;
        case '3':  retStr = 'LG U+(시내)'; break;
        case '4':  retStr = '온세텔레콤'; break;
        case '4001':  retStr = '텔레센트로'; break;
        case '9':  retStr = 'SK텔링크'; break;
        case '9001':  retStr = 'C&M'; break;
        case '9003':  retStr = 'GS강남방송'; break;
        case '9004':  retStr = 'GS울산방송'; break;
        case '9006':  retStr = 'CJ중부산케이블'; break;
        case '9014':  retStr = '브이엘씨'; break;
        case '9015':  retStr = '원포유텔레콤'; break;
        case '9016':  retStr = '한국전파기지국'; break;
        case '9017':  retStr = 'ATI정보통신'; break;
        case '9018':  retStr = 'CTN텔레콤'; break;
        case '9020':  retStr = 'RPK'; break;
        case '9021':  retStr = '프리즘커뮤니케이션즈'; break;
        case 'A':  retStr = 'SK네트웍스'; break;
        case 'A001':  retStr = '큰사람컴퓨터'; break;
        case 'A002':  retStr = '포스데이타㈜'; break;
        case 'A003':  retStr = '씨브이네트'; break;
        case 'A004':  retStr = '빅아이텔'; break;
        case 'A005':  retStr = '모빌씨앤씨'; break;
        case 'A006':  retStr = '프리즘커뮤니케이션스㈜'; break;
        case 'A007':  retStr = '주식회사 아이투라인'; break;
        case 'A008':  retStr = '유윈'; break;
        case '9011':  retStr = '굿텔레콤'; break;
        case '9012':  retStr = '대림I&S'; break;
        case '9013':  retStr = '라온에스씨'; break;
        case 'A011':  retStr = '(주)렛츠070'; break;
        case 'G043':  retStr = 'SK텔레콤'; break;
        case 'G030':  retStr = '엠에스에이커뮤니케이션'; break;
        case 'G031':  retStr = '파티에스코리아'; break;
        case 'H':  retStr = '데이콤(인터넷)'; break;
        case 'H001':  retStr = 'LG파워콤'; break;
        case 'H002':  retStr = '씨토크'; break;
        case 'I':  retStr = '몬티스타텔레콤'; break;
        case 'F006':  retStr = '앰앤텔레콤'; break;
        case 'F009':  retStr = '유앤텔'; break;
        case 'G007':  retStr = '야후코리아'; break;
        case 'G032':  retStr = '싸이버로지텍'; break;
        case 'G036':  retStr = '프리즘'; break;
        case 'G037':  retStr = '라온에스씨'; break;
        case 'G038':  retStr = '123텔레콤'; break;
        case 'G039':  retStr = '한국전파기지국'; break;
        case 'G040':  retStr = '글로브네트웍스'; break;
        case 'G041':  retStr = '큰사람컴퓨터'; break;
        case 'G042':  retStr = '도시가스'; break;
        case 'B022':  retStr = '금강방송'; break;
        case 'B023':  retStr = '대구방송'; break;
        case 'G033':  retStr = '무한넷'; break;
        case 'G034':  retStr = '현대오토에버시스템즈'; break;
        case 'G035':  retStr = '처음넷'; break;
        case 'A010':  retStr = 'EICN'; break;
        case 'F019':  retStr = '제이에스솔류션'; break;
        case 'F020':  retStr = '포스데이타'; break;
        case 'F021':  retStr = '라온에스씨'; break;
        case 'F012':  retStr = '아톤텔레콤'; break;
        case 'G':  retStr = 'SK브로드밴드(인터넷)'; break;
        case 'G001':  retStr = '원텔'; break;
        case 'G002':  retStr = '브릿지원커뮤니케이션즈'; break;
        case 'G003':  retStr = '나라비전'; break;
        case 'G005':  retStr = '큰길 유윈'; break;
        case 'G006':  retStr = '아이투라인'; break;
        case 'G008':  retStr = '넥스텔레콤'; break;
        case 'G009':  retStr = '유니컴버스'; break;
        case 'G011':  retStr = '케이에프텔'; break;
        case 'G012':  retStr = '텔레센트로'; break;
        case 'G013':  retStr = '롯데정보통신'; break;
        case 'G017':  retStr = '큰길네트웍스'; break;
        case 'G019':  retStr = '허드슨텔레콤'; break;
        case 'G021':  retStr = '텔라인네트웍스'; break;
        case 'G022':  retStr = '디엔비네트워크'; break;
        case 'G023':  retStr = '다이너스티텔레콤'; break;
        case 'G024':  retStr = '다이얼커뮤니케이션'; break;
        case 'G026':  retStr = '한국인터넷텔레콤'; break;
        case 'G027':  retStr = '큐넷커뮤니케이션즈'; break;
        case 'G028':  retStr = '글로벌아이티아웃소싱'; break;
        case 'G029':  retStr = '프리즘커뮤니케이션스'; break;
        case '9022':  retStr = '동방시스템'; break;
        case 'B024':  retStr = '씨씨에스'; break;
        case 'B025':  retStr = '포항종합케이블'; break;
        case 'A012':  retStr = '주식회사 벤치비'; break;
        case 'A014':  retStr = '㈜레이텔레콤'; break;
        case 'A015':  retStr = '㈜보이텔커뮤니케이션'; break;
        case 'A016':  retStr = '㈜세중게임즈 종로지점'; break;
        case 'A017':  retStr = '㈜옥션'; break;
        case 'A018':  retStr = '주식회사 지엔씨텔링크'; break;
        case 'A019':  retStr = '런스타주식회사'; break;
        case 'J':  retStr = 'SB인터랙티브'; break;
        case 'J001':  retStr = '씨씨에스'; break;
        case 'J002':  retStr = '영서방송'; break;
        case 'C003':  retStr = '현대에이치씨엔'; break;
        case '2001':  retStr = 'SK텔레콤'; break;
        case 'C002':  retStr = '동서디지털방송'; break;
      }
      return retStr
    },


    checkNumbers(){
      //4자리 포맷으로 맞추기
      this.registration.moveInfo.moveTlno = this.format4(this.registration.moveInfo.trno) + this.format4(this.registration.moveInfo.txno) + this.format4(this.registration.moveInfo.tsno)

      if(this.registration.crplZpcd === ''){
        this.openAlert('온라인 가입신청 안내', '주소를 먼저 입력해주시기 바랍니다.')
        return
      }
      //우편번호로 지역번호 확인
      getAreaNoBtZpcd(this.registration.crplZpcd)
          .then(res => {
            let resultCd = res.data.dsRsltInfo.rsltCd
            let resultMsg = res.data.dsRsltInfo.rsltMsg
            if (resultCd === 'SUCCESS') {
              let tmp = {}
              tmp = res.data.dsOutput[0]
              if(!tmp){
                // this.openAlert('온라인 가입신청 안내', '확인 불가')
                // return
              }
              else{
                this.registration.moveInfo.areaNoBtZpcdInfo1.zip = tmp.zip
                this.registration.moveInfo.areaNoBtZpcdInfo1.bfrTrno = tmp.bfrTrno//이전지역전화번호
                this.registration.moveInfo.areaNoBtZpcdInfo1.beginTrnoDvCd = tmp.beginTrnoDvCd//신규지역전화번호
                this.registration.moveInfo.areaNoBtZpcdInfo1.commCdVal = tmp.commCdVal
                this.registration.moveInfo.areaNoBtZpcdInfo1.commCdValDesc = tmp.commCdValDesc
              }
              tmp = res.data.dsOutput[1]
              if(!tmp){
                // this.openAlert('온라인 가입신청 안내', '확인 불가')
                // return
              }
              else{
                this.registration.moveInfo.areaNoBtZpcdInfo2.zip = tmp.zip
                this.registration.moveInfo.areaNoBtZpcdInfo2.bfrTrno = tmp.bfrTrno//이전지역전화번호
                this.registration.moveInfo.areaNoBtZpcdInfo2.beginTrnoDvCd = tmp.beginTrnoDvCd//신규지역전화번호
                this.registration.moveInfo.areaNoBtZpcdInfo2.commCdVal = tmp.commCdVal
                this.registration.moveInfo.areaNoBtZpcdInfo2.commCdValDesc = tmp.commCdValDesc
              }
            }
            else{
              this.openAlert('온라인 가입신청 안내', '번호이동 번호 확인 중 오류가 발생하였습니다. 잠시 후 다시 시도바랍니다.')
              return
            }
          })
          .catch(e => {
          })

      //번호이동 가능여부 체크
      getFpnRqstPsblYn(this.format4(this.registration.moveInfo.trno),this.format4(this.registration.moveInfo.txno),this.format4(this.registration.moveInfo.tsno))
          .then(res => {
            let resultCd = res.data.dsRsltInfo.rsltCd
            let resultMsg = res.data.dsRsltInfo.rsltMsg
            if (resultCd === 'SUCCESS') {
              let tmp = {}
              tmp = res.data.dsOutput[0]
              if(!tmp) {
                // this.openAlert('온라인 가입신청 안내', '확인 불가')
                // return
              }
              else{
                this.registration.moveInfo.fpnRqstPsblYnInfo.entrNo =  tmp.entrNo
                this.registration.moveInfo.fpnRqstPsblYnInfo.mnpTrdtPrssDvCd =  tmp.mnpTrdtPrssDvCd
                this.registration.moveInfo.fpnRqstPsblYnInfo.rlopnSucsDvCd =  tmp.rlopnSucsDvCd
                this.registration.moveInfo.fpnRqstPsblYnInfo.mnpPrgrsSttsDvCd =  tmp.mnpPrgrsSttsDvCd
              }
            }
            else{
              this.openAlert('온라인 가입신청 안내', '번호이동 번호 확인 중 오류가 발생하였습니다. 잠시 후 다시 시도바랍니다.')
              return
            }

          })
          .catch(e => {
          })

      //번호이동번호 변경전 사업자 조회
      getFnpPrevEnpr(this.registration.crplZpcd ,this.format4(this.registration.moveInfo.trno),this.format4(this.registration.moveInfo.txno),this.format4(this.registration.moveInfo.tsno))
              .then(res => {
                let resultCd = res.data.dsRsltInfo.rsltCd
                let resultMsg = res.data.dsRsltInfo.rsltMsg
                if (resultCd === 'SUCCESS') {
                  let tmp = {}
                  tmp = res.data.dsOutput[0]
                  if(!tmp) {
                    // this.openAlert('온라인 가입신청 안내', '확인 불가')
                    // return
                  }
                  else{
                    this.registration.moveInfo.fnpPrevEnprInfo.cnt =  tmp.cnt
                    this.registration.moveInfo.fnpPrevEnprInfo.noGrntEnpr =  tmp.noGrntEnpr
                    this.registration.moveInfo.fnpPrevEnprInfo.prevEnpr =  tmp.prevEnpr
                    this.registration.moveInfo.fnpPrevEnprInfo.noGrntXetpr =  tmp.noGrntXetpr
                    this.registration.moveInfo.fnpPrevEnprInfo.prevXetpr =  tmp.prevXetpr

                    //2. 변경전사업자 정보 세팅
                    this.registration.moveInfo.fnpPrevEnprInfo.prevEnprNm = this.getCorpNm(this.registration.moveInfo.fnpPrevEnprInfo.prevEnpr)//이전사업자
                    this.registration.moveInfo.fnpPrevEnprInfo.noGrntXetprNm = this.getCorpNm(this.registration.moveInfo.fnpPrevEnprInfo.noGrntXetpr)//이전 별정사업자

                    this.registration.moveInfo.beforeBuisness = this.registration.moveInfo.fnpPrevEnprInfo.prevEnprNm

                  }
                }
                else{
                  this.openAlert('온라인 가입신청 안내', '번호이동 번호 확인 중 오류가 발생하였습니다. 잠시 후 다시 시도바랍니다.')
                  return
                }

              })
              .catch(e => {
              })


      //validation
      if(!(this.registration.moveInfo.fpnRqstPsblYnInfo.mnpTrdtPrssDvCd === '1100' ||
              this.registration.moveInfo.fpnRqstPsblYnInfo.mnpTrdtPrssDvCd === '1600' ||
              this.registration.moveInfo.fpnRqstPsblYnInfo.mnpTrdtPrssDvCd === '1660' ||
              this.registration.moveInfo.fpnRqstPsblYnInfo.mnpTrdtPrssDvCd === '8700' ||
              this.registration.moveInfo.fpnRqstPsblYnInfo.mnpTrdtPrssDvCd === '3300' ||
              (this.registration.moveInfo.fpnRqstPsblYnInfo.mnpTrdtPrssDvCd === '1900' && this.registration.moveInfo.fpnRqstPsblYnInfo.rlopnSucsDvCd !== '0') ||
              this.registration.moveInfo.fpnRqstPsblYnInfo.mnpTrdtPrssDvCd === '')){
        this.openAlert('온라인 가입신청 안내', '다른 고객분께서 신청하신 번호입니다. 다른 번호를 입력해주세요.')
        return
      }
      if(this.registration.moveInfo.fnpPrevEnprInfo.prevEnpr === ''){
        this.openAlert('온라인 가입신청 안내', '변경 전 사업자 정보가 없습니다.')
        return
      }

      //번호이동확인 성공시
      //1.번호이동번호 비활성화. 버튼 비활성화
      //2.변경전사업자 정보 세팅
      //3.변경전사업자가 KT 일경우 설치비 반환정보 활성화   befrChgCpTyp = 1

      //1. 번호이동번호 비활성화. 버튼 비활성화
      this.registration.moveInfo.ischeck = true

    },

    editNumbers(){
      this.registration.moveInfo.ischeck = false
    },

    clickHomeCntn(event){
      let tmpId = event.target.id.split('-')[1]
      this.registration.homeCntnStatus[event.target.id] = event.target.checked
      //홈계약정보 찾기
      for(let i = 0; i< this.registration.homeCntnInfo.length;i++){
        if(this.registration.homeCntnInfo[i].cnvgNo !== tmpId){
          continue
        }
        else{
          //홈 계약정보 복붙
          this.appfData.cnvgNo=this.registration.homeCntnInfo[i].cnvgNo//서비스 추가 시 사용
          this.appfData.sbcContNo=this.registration.homeCntnInfo[i].sbcContNo//서비스 추가 시 사용
          this.estbAllAddr = this.registration.homeCntnInfo[i].estbAllAddr
          this.estbProdNm = this.registration.homeCntnInfo[i].prodNm
        }
      }
    },

    submitEmail(){
      let title = '온라인 가입신청 안내'
      if (!this.registration.emailId) {
        this.openAlert(
          title,
          '이메일 아이디를 입력해주세요.',
          this.$refs.ref_emailId
        )
        return
      }
      
      if (!this.registration.emailDomain) {
        this.openAlert(
          title,
          '이메일 도메인을 입력해주세요.',
          this.$refs.ref_emailDomain
        )
        return
      }
      
      let message = ''
      let billEmailAddr =
        this.registration.emailId +
        '@' +
        this.registration.emailDomain

      if (billEmailAddr.length > 50) {
        this.openAlert(
          title,
          '허용된 이메일 자릿수를 초과하였습니다.\n다른 이메일로 입력바랍니다.',
          this.$refs.ref_emailId
        )
        return
      }
      getBlEmailBlock(billEmailAddr).then(res => {
        let blackRegYn = res.data.dsRes.blackRegYn
        let blockCntYn = res.data.dsRes.blockCntYn
        if (blackRegYn === 'Y') {
          message =
            '등록하신 이메일 주소는 등록이 제한된 이메일 주소 입니다.\n이메일 주소를 확인하시어 다른 이메일 주소로 등록 해주십시오.\n(이메일 주소 이용자가 발송 차단 요청, 타인 이메일 청구서 다량 수신 건으로 등록 차단 요청)'
          this.chkEmailAgree = false
        } else if (blockCntYn === 'Y') {
          message =
            '등록하신 이메일 주소는 등록제한 횟수(5건)를 초과한 \n이메일 주소입니다.\n해당 이메일 주소로는 등록이 불가하오니, 다른 이메일 주소를 확인하시어 등록해 주십시오.'
          this.chkEmailAgree = false
        } else {
          message = '이메일 확인 성공하였습니다!'
          this.registration.email = billEmailAddr
          this.chkEmailAgree = true
        }
        this.openAlert(title, message)
      })
    },

    chgEmailDomain(){
      if (this.selectedEmailDomain !== "") {
        this.registration.emailDomain = this.selectedEmailDomain
      } else {
        this.registration.emailDomain = ""
      }
    },
    
    copyInfo(){
      this.registration.moveInfo.titleHolder.name = this.registration.name //이름 복사
      this.registration.moveInfo.titleHolder.tlno_trno = this.registration.tlno_trno //일반전화 복사
      this.registration.moveInfo.titleHolder.tlno_txno = this.registration.tlno_txno //일반전화 복사
      this.registration.moveInfo.titleHolder.tlno_tsno = this.registration.tlno_tsno //일반전화 복사
      //KMC 인증일 경우 selectbox setting --> 통신사
      this.registration.moveInfo.titleHolder.phonCorp = this.registration.phonCorp
      this.registration.moveInfo.titleHolder.phonNo_trno = this.registration.authTlno_trno//휴대폰전화 탭에서 이동전화 복사
      this.registration.moveInfo.titleHolder.phonNo_txno = this.registration.authTlno_txno//휴대폰전화 탭에서 이동전화 복사
      this.registration.moveInfo.titleHolder.phonNo_tsno = this.registration.authTlno_tsno//휴대폰전화 탭에서 이동전화 복사
      this.registration.moveInfo.titleHolder.info.year = this.registration.birthYear//명의인 입력정보 -> 년
      this.registration.moveInfo.titleHolder.info.month = this.registration.birthMonth//명의인 입력정보 -> 월
      this.registration.moveInfo.titleHolder.info.date = this.registration.birthDate//명의인 입력정보 -> 일
      this.registration.moveInfo.titleHolder.info.sex = this.registration.sex//명의인 입력정보 -> 성별
      this.registration.moveInfo.titleHolder.info.isDomestic = this.registration.isDomestic//명의인 입력정보 -> 내/외국인
    },




    chgContractInfo(){
      if(this.registration.moveInfo.contractInfoCode === '4'){
        this.registration.moveInfo.contractInfoDetail = '0000';
      }
      else {
        this.registration.moveInfo.contractInfoDetail = '';
      }
    },

    beforeSaveValidation(){
      //유치점 선택 확인
      if(this.registration.dealer.selrId ===''){
        this.openAlert('온라인 가입신청 안내', '유치점 선택 바랍니다.')
        return false
      }

      //필수 동의란 체크 확인
      // 개인정보 compliance 점검결과적용 2025.02.12
     // if(!this.agreement.personalInfoEssential || !this.agreement.personalInfoEntrust){
      if(!this.agreement.personalInfoEssential){
        this.openAlert('온라인 가입신청 안내', '(필수)개인정보 수집에 동의해주시기 바랍니다.')
        return false
      }

      //이름
      if(this.registration.name ===''){
        this.openAlert('온라인 가입신청 안내', '이름을 입력해 주시기 바랍니다.')
        return false
      }

      //인증유무
      if(!this.isAuth){
        this.openAlert('온라인 가입신청 안내', '인증을 진행 후 다음으로 이동이 가능합니다.')
        return false
      }

      //서비스는 하나 이상 신청해야함..
      if(!this.service.chkInternet && !this.service.chkInternetPhone && !this.service.chkTV && !this.service.chkIoT && !this.service.chkExclusive){
        this.openAlert('온라인 가입신청 안내', '서비스는 하나 이상 선택해 주시기 바랍니다.')
        return false
      }

      //일반전화는 없어도 됨됨
      //인증 이동전화유무
      if(this.registration.authTlno_trno ===''
      || this.registration.authTlno_txno ===''
      || this.registration.authTlno_tsno ===''){
        this.openAlert('온라인 가입신청 안내', '상세정보입력 > 이동전화를 정확히 입력해 주시기 바랍니다.')
        return false
      }

      //이메일 없어도됨.
      //이메일 있을 시 이메일 체크 확인
      if(!this.chkEmailAgree){
        if(this.registration.emailId === '' &&  this.registration.emailDomain === ''){
          //pass
        }
        else{
          this.openAlert('온라인 가입신청 안내', '이메일 입력 시 이메일 확인은 필수입니다.')
          return false
        }
      }
      else{
        if(this.registration.emailId === '' || this.registration.emailDomain === ''){
          this.openAlert('온라인 가입신청 안내', '이메일을 정확히 입력하시기 바랍니다.')
          return false
        }
      }

      if(this.registration.crplZpcd ===''
              || this.registration.crplAddr ===''
              || this.registration.crplDadr ===''){
        this.openAlert('온라인 가입신청 안내', '주소를 정확히 입력해 주시기 바랍니다.')
        return false
      }

      //번호이동은 서비스구분이 홈일때 가능
      if(this.service.moveYn && this.service.isHome){
        //번호이동 시 상기 내용 확인 체크했는지
        if(!this.isMoveCheck){
          this.openAlert('온라인 가입신청 안내', '번호이동 필수 안내사항을 확인바랍니다.')
          return false
        }
        //번호이동 시 번호이동 전화번호 공란 확인
        if(this.registration.moveInfo.trno === ''
                ||this.registration.moveInfo.txno === ''
                ||this.registration.moveInfo.tsno === ''){
          this.openAlert('온라인 가입신청 안내', '번호이동 전화번호를 정확히 입력해 주시기 바랍니다.')
          return false
        }

        //번호이동 시 번호확인 체크 유무
        if(!this.registration.moveInfo.ischeck){
          this.openAlert('온라인 가입신청 안내', '번호이동 전화번호의 번호확인 후 신청가능합니다.')
          return false
        }

        //번호이동 시 변경 전 사업자 확인
        if(this.registration.moveInfo.beforeBuisness === ''){
          this.openAlert('온라인 가입신청 안내', '번호이동 변경전 사업자가 없습니다. 확인 후 신청바랍니다.')
          return false
        }

        //번호이동 시 명의인 이름
        if(this.registration.moveInfo.titleHolder.name === ''){
          this.openAlert('온라인 가입신청 안내', '번호이동 명의인 이름을 가입자정보 복사입력 버튼을 통해 입력해 주시기 바랍니다.')
          return false
        }

        //번호이동 시 명의인 일반전화는 없어도 됨
        //번호이동 시 명의인 이동전화 , 이동전화 통신사
        if(this.registration.moveInfo.titleHolder.phonNo_trno === ''||
                this.registration.moveInfo.titleHolder.phonNo_txno === ''||
                this.registration.moveInfo.titleHolder.phonNo_tsno === ''
        ){
          this.openAlert('온라인 가입신청 안내', '번호이동 명의인 이동전화를 가입자정보 복사입력 버튼을 통해 입력해 주시기 바랍니다.')
          return false
        }
        if( this.registration.moveInfo.titleHolder.phonCorp === '' ){
          this.openAlert('온라인 가입신청 안내', '번호이동 명의인 이동전화의 통신사를 입력해 주시기 바랍니다.')
          return false
        }

        //번호이동 시 청구계약정보 선택
        if(this.registration.moveInfo.contractInfoCode === '' ){
          this.openAlert('온라인 가입신청 안내', '청구계약정보를 선택해 주시기 바랍니다.')
          return false
        }

        //번호이동 시 청구계약정보 네자리 유무
        if(this.registration.moveInfo.contractInfoDetail === '' ){
          this.openAlert('온라인 가입신청 안내', '청구계약정보를 입력해 주시기 바랍니다.')
          return false
        }

        //번호이동 시, 계좌이체 선택 시
        if(this.registration.moveInfo.instlCostRfndYn === 'Y' && (this.registration.moveInfo.bankDetail === '' || this.registration.moveInfo.bankCorp === '')){//계좌수령 시 은행명과 은행계좌번호 체크
          this.openAlert('온라인 가입신청 안내', '은행명과 계좌번호를 정확히 입력바랍니다.')
          return false
        }


      }

      //soho&&인터넷전화인데 회선수가 빈값일떄
      if(!this.service.isHome && this.service.chkInternetPhone && this.service.line_cnt === ''){
        this.openAlert('온라인 가입신청 안내', '회선 수를 입력바랍니다.')
        return false
      }

      //soho&&인터넷전화일 경우 번이 불가
      if(!this.service.isHome && this.service.moveYn){
        this.openAlert('온라인 가입신청 안내', '소호는 번호이동이 불가합니다.')
        return false
      }

      //청소년일 경우
      if(this.checkTeenager()){
        this.openAlert('온라인 가입신청 안내', '죄송합니다. 회원님께서는 현재 미성년자로 서비스가입신청이 불가합니다. 해당명의로 가입하시기 위해서는 부모님의 동의절차가 필요 하오니 다른 명의로 가입하시거나, 고객센터(☎1644-7000)로 문의 주시기 바랍니다.')
        return false
      }

      //기존신청서일때
      if(!this.isNew){
        if(this.appfData.sbcContNo === '' || !this.appfData.sbcContNo){
          //사용중인 상품 미체크시
          this.openAlert('온라인 가입신청 안내', '기존 서비스 신청 시 사용중인 상품을 선택해 주시기 바랍니다.')
          return false
        }
      }
     
      return true
    },

    save(){
      //validation 및 신청서 state에 저장
      if(!this.beforeSaveValidation()) return

      if(!this.saveAppfData()) return

       //최종 저장시 인증한 정보와 신청서 정보가 일치하는지 확인하는 validation --> (step2->step3)에도 추가
    /*  if(this.$store.state.appfData.custNm !== this.$store.state.appfData.moct_name
              || this.registration.birthYear.substr(2,2) + this.registration.birthMonth + this.registration.birthDate !== this.$store.state.appfData.moct_birthDay){
        this.openAlert('온라인 가입신청 안내', '가입자 정보와 인증 정보가 일치하지 않습니다. 확인 후 재신청바랍니다.[A]')
        return
      }
      */

       //DB 저장값과 비교
      getTpsAutnInfo(this.appfData).then(res => {
        let juminNo = res.data.juminNo
        let custName = res.data.custName

       if(juminNo.length>6) juminNo=juminNo.substr(2,6)
        if (custName !== this.$store.state.appfData.moct_name||this.$store.state.appfData.custNm!==this.$store.state.appfData.moct_name) {
           this.openAlert('온라인 가입신청 안내', '가입자 정보와 인증 정보가 일치하지 않습니다. 확인 후 재신청바랍니다.[A]')
          return 
        }else if (this.$store.state.appfData.moct_birthDay !== this.registration.birthYear.substr(2,2) + this.registration.birthMonth + this.registration.birthDate 
           ||this.$store.state.appfData.moct_birthDay!==juminNo) {
           this.openAlert('온라인 가입신청 안내', '가입자 정보와 인증 정보가 일치하지 않습니다. 확인 후 재신청바랍니다.[B]')
          return 

        } else{

          routerHome.push({ name: 'OnsaleHomeStep2' })
        }
      })
     
    },

    //state에 신청서 정보 저장.
    saveAppfData(){

      let tmpProdCnt = 0
      let tmpSnglSppsRqstYn = 'N'
      if(this.service.chkInternet){
        tmpProdCnt++
      }
      if(this.service.chkInternetPhone){
        tmpProdCnt++
      }
      if(this.service.chkTV){
        tmpProdCnt++
      }
      if(this.service.chkIoT){
        if(tmpProdCnt === 0) tmpSnglSppsRqstYn = 'Y'
        tmpProdCnt++
      }
      if(this.service.chkExclusive){
        tmpProdCnt = 1
        tmpSnglSppsRqstYn ='Y'
      }
      if(!this.service.chkInternet && !this.service.chkInternetPhone){
        tmpSnglSppsRqstYn ='Y'
      }

      let prodCd0 = ''
      let prodCd1 = ''
      let prodCd2 = ''
      let prodCd3 = ''
      let svcCd0 = ''
      let svcCd1 = ''
      let svcCd2 = ''
      let svcCd3 = ''
      //상품코드,서비스코드,가입계약번호
      if(this.service.chkInternet === true
              && this.service.chkInternetPhone === false
              && this.service.chkTV === false){//인터넷단독
        prodCd0 = "LZP0000601";	//상품코드
        svcCd0 = "LPZ0030023";		//서비스코드
      }
      if(this.service.chkInternet === true
              && this.service.chkInternetPhone === true
              && this.service.chkTV === false){//070번들
        prodCd0 = "LZP0000601";	//상품코드

        //soho 선택시 070선택시 서비스 코드 변경(LZP0000304)
        if(this.service.isHome === false){
          prodCd1 = "LZP0000304";	//상품코드
        }else{
          prodCd1 = "LZP0000301";	//상품코드
        }
        svcCd0 = "LPZ0030023";		//서비스코드
        svcCd1 = "LPZ0030003";		//서비스코드
      }
      if(this.service.chkInternet == false
              && this.service.chkInternetPhone == true
              && this.service.chkTV == false){//070단독

        //soho 선택시 070선택시 서비스 코드 변경(LZP0000304)
        if($('input[id=entrRsvRqstSoho]:radio').is(':checked') === true){
          prodCd0 = "LZP0000304";	//상품코드
        }else{
          prodCd0 = "LZP0000301";	//상품코드
        }
        svcCd0 = "LPZ0030003";		//서비스코드
      }
      if(this.service.chkInternet === true
              && this.service.chkInternetPhone === false
              && this.service.chkTV === true){//iptv번들
        prodCd0 = "LZP0000601";	//상품코드
        prodCd1 = "LZP0000701";	//상품코드
        svcCd0 = "LPZ0030014";		//서비스코드
        svcCd1 = "LPZ0030023";		//서비스코드
      }
      if(this.service.chkInternet === false
              && this.service.chkInternetPhone === false
              && this.service.chkTV === true){//iptv단독
        prodCd0 = "LZP0000701";	//상품코드
        svcCd0 = "LPZ0030023";		//서비스코드
      }
      if(this.service.chkInternet === true
              && this.service.chkInternetPhone === true
              && this.service.chkTV === true){//TPS
        prodCd0 = "LZP0000601";	//상품코드
        prodCd1 = "LZP0000701";	//상품코드
        //soho 선택시 070선택시 서비스 코드 변경(LZP0000304)
        if(this.service.isHome ===false){
          prodCd2 = "LZP0000304";	//상품코드
        }else{
          prodCd2 = "LZP0000301";	//상품코드
        }
        svcCd0 = "LPZ0030023";		//서비스코드
        svcCd1 = "LPZ0030014";		//서비스코드
        svcCd2 = "LPZ0030003";		//서비스코드
      }

      if(this.service.chkInternet === false
              && this.service.chkInternetPhone === true
              && this.service.chkTV === true){//인터넷(X) + 070(O) + TV(O)
        //soho 선택시 070선택시 서비스 코드 변경(LZP0000304)
        if(this.service.isHome === false){
          prodCd0 = "LZP0000304";	//상품코드
        }else{
          prodCd0 = "LZP0000301";	//상품코드
        }
        svcCd0 = "LPZ0030003";	//서비스코드
        prodCd1 = "LZP0000701";	//상품코드
        svcCd1 = "LPZ0030023";		//서비스코드
      }

      if(this.service.chkIoT === true ){//IoT (TV, IOT 안묶임)
        // TV, IOT 안묶이게처리
        /*
        */
        if ( tmpProdCnt===2 && this.service.chkTV === true  ){
          alert('U+TV 와 U+IoT@Home 는 묶음상품이 될 수 없습니다.')
          return false;
        }

        if ( tmpProdCnt===1 ){
          prodCd0 = "LZP0000107";	//상품코드
          svcCd0 = "LPZ0030112";		//서비스코드
        }

        if ( tmpProdCnt===2 ){
          prodCd1 = "LZP0000107";	//상품코드
          svcCd1 = "LPZ0030112";		//서비스코드
        }

        if ( tmpProdCnt===3 ){
          prodCd2 = "LZP0000107";	//상품코드
          svcCd2 = "LPZ0030112";		//서비스코드
        }

        if ( tmpProdCnt===4 ){
          prodCd3 = "LZP0000107";	//상품코드
          svcCd3 = "LPZ0030112";		//서비스코드
        }
      }

      if(this.service.chkExclusive === true ){ // 부가단독
        if ( this.service.chkTrue === true ){
          prodCd0 = "LZP0000601"; //상품코드
          svcCd0 = "LPZ0030073"; //서비스코드
        }
      }

      this.appfData.prodCdCnt=tmpProdCnt.toString() //service 개수
      //유치점정보세팅
      this.appfData.csalesCd= this.registration.dealer.csalesCd
      this.appfData.selrId= this.registration.dealer.selrId
      this.appfData.selrTyp= this.registration.dealer.selrTyp
      this.appfData.tmpAplyTyp= (this.isNew)? this.registration.dealer.tmpAplyTyp: '16'//신규면 15, 기존이면 16
      this.appfData.selTyp= this.registration.dealer.selTyp
      this.appfData.selPathCd= this.registration.dealer.selPathCd
      this.appfData.dlrCd= this.registration.dealer.dlrCd
      this.appfData.posCd= this.registration.dealer.posCd //add_20201021_posCd
      this.appfData.dlrNm= this.registration.dealer.rmk// 대리점 명 장희정 추가

      //신청서 정보 세팅
      this.appfData.custNm= this.registration.name
      this.appfData.custNmY=''//사용안함
      this.appfData.custTyp='1' //1:개인,3:사업자,4:외국인식별
      this.appfData.idenNo='' //사용안함 주민번호
      this.appfData.idenNoY=''//사용안함
      this.appfData.idenNoY1=''//사용안함
      this.appfData.idenNoTyp='1'//실명인증폼 1:개인,3:사업자,4:외국인식별
      this.appfData.payType=''//사용안함
      this.appfData.bank=''//사용안함
      this.appfData.card=''//사용안함
      this.appfData.bankAccount=''
      this.appfData.cardYY=''//사용안함
      this.appfData.cardMM=''//사용안함
      this.appfData.chargeSendType=''//사용안함
      this.appfData.isDomestic = this.registration.isDomestic //내국인, 외국인 여부 
      this.appfData.telNo=this.format4(this.registration.tlno_trno) +this.format4(this.registration.tlno_txno) + this.format4(this.registration.tlno_tsno) //일반전화
      this.appfData.ptTelNo=this.format4(this.registration.authTlno_trno) +this.format4(this.registration.authTlno_txno) + this.format4(this.registration.authTlno_tsno) //이동전화
      this.appfData.email=(this.registration.email)?this.registration.email:''//이메일
      this.appfData.prodCd=''//사용안함
      this.appfData.spclDet=(this.registration.spclDet)?this.registration.spclDet:''//기타요청사항
      this.appfData.instlZipCd=this.registration.crplZpcd//우편번호
      this.appfData.instlAddrN=this.registration.crplAddr//시도,시군구,도로명,건물번호

      this.appfData.instlResidTyp=''//x
      this.appfData.instlSdNm=''//시도
      this.appfData.instlSggNm=''//시군구
      this.appfData.instlEmdNm=''//읍면동
      this.appfData.instlTownNm=''//동
      this.appfData.instlRoadNm=''//도로명
      this.appfData.instlBjdongNo=''//x
      this.appfData.instlBldNm=''//건물명
      this.appfData.instlLiNm=''//리
      this.appfData.instlIslndNm=''
      this.appfData.instlBldrpstNo=''//건물번호(본번)
      this.appfData.instlBldsubNo=''//건물번호(부번)
      this.appfData.instlBldrpstNoA=''//건물번호(본번+부번)
      this.appfData.instlAptDong=''//아파트동
      this.appfData.instlAptHo=''//아파트호
      this.appfData.instlHsno=''
      this.appfData.instlAddrHo=''
      this.appfData.instlExtAddrSpec=this.registration.crplDadr//상세주소
      this.appfData.instlLandcateTyp=''
      this.appfData.instlHjdongNo=''

      this.appfData.instlAddr=this.registration.crplAddr//가입화면에 보여주는 주소
      this.appfData.instlSchDvCd='2'//주소구분타입 (2:도로명, 1:지번)
      this.appfData.instAddrResult='1'//주소구분타입 (1:도로명, 2:지번)
      this.appfData.instlRoadNm1=''//사용안함
      this.appfData.instlRoadNm2=''//사용안함
      this.appfData.instlRoadNm3=''//사용안함
      this.appfData.sbcMthdTyp='3' //청약방법 : 온라인신청 hardcoding
      this.appfData.certiMthdTyp=(this.authCd === 'KMC' || this.authCd === 'SMS' )? 'M' : 'I' //인증방법 KMC(SMS) : 'M' // ipin : 'I'
      if(this.appfData.certiMthdTyp === 'I'){
        this.appfData.moct_phoneNo = this.format4(this.registration.authTlno_trno) +this.format4(this.registration.authTlno_txno) + this.format4(this.registration.authTlno_tsno)
      }
      this.appfData.encryptIdenNo=''//사용안함 인증주민번호
      this.appfData.certiOrganTyp='1'//certiOrganTyp인증기관 hardcoding
      this.appfData.certiTm=''//인증시간
      this.appfData.certiRequestNo=''//인증요청번호
      this.appfData.certiResponseNo=''//인증응답번호
      this.appfData.certiSuccessYn=(this.isAuth)?'Y':'N'//인증성공여부
      this.appfData.aplyrHpWapPsblYn=''//사용안함 WAP가능여부
      this.appfData.telecCoTyp=''//사용안함 통신사
      this.appfData.wapSndCorpNo=''//사용안함 wapSndCorpNo WAP발송통신사구분
      this.appfData.hpCertiYn=''//사용안함 휴대폰인증여부
      this.appfData.nmptYn=(this.service.moveYn)?"Y" :"N"//번호이동여부
      this.appfData.nmpt_befrChgCpNm=(this.registration.moveInfo.fnpPrevEnprInfo.prevEnprNm)? this.registration.moveInfo.fnpPrevEnprInfo.prevEnprNm:''//변경전사업자명
      this.appfData.nmpt_befrChgCpTyp=(this.registration.moveInfo.fnpPrevEnprInfo.prevEnpr)?this.registration.moveInfo.fnpPrevEnprInfo.prevEnpr:''//변경전사업자
      this.appfData.nmpt_befrChgSctCpNm=(this.registration.moveInfo.fnpPrevEnprInfo.noGrntXetprNm)?this.registration.moveInfo.fnpPrevEnprInfo.noGrntXetprNm:''//변경전 별정사업자명
      this.appfData.nmpt_befrChgSctCpTyp=(this.registration.moveInfo.fnpPrevEnprInfo.noGrntXetpr)?this.registration.moveInfo.fnpPrevEnprInfo.noGrntXetpr:''//변경전 별정사업자
      this.appfData.nmpt_custRelTyp=''//명의인과 관계
      this.appfData.nmpt_instlCostRfndYn=(this.registration.moveInfo.instlCostRfndYn)?this.registration.moveInfo.instlCostRfndYn:'N'//설비비안내 없음 N / 계좌수령 Y / 직접수령 D
      this.appfData.nmpt_instlCostRfndAcntNo=(this.registration.moveInfo.bankDetail)?this.registration.moveInfo.bankDetail:''//번호이동계좌번호
      this.appfData.nmpt_instlCostRfndBankNm=(this.registration.moveInfo.bankCorp)?this.registration.moveInfo.bankCorp:''//번호이동은행명
      this.appfData.nmpt_aplyrNm=(this.registration.moveInfo.titleHolder.name)?this.registration.moveInfo.titleHolder.name:''
      this.appfData.nmpt_aplyrIdenNo=''//사용 안함 가입자 주민번호 동일
      this.appfData.nmpt_aplyrTelNo=this.format4(this.registration.tlno_trno) + this.format4(this.registration.tlno_txno) + this.format4(this.registration.tlno_tsno)
      this.appfData.nmpt_aplyrPtTelNo=this.format4(this.registration.authTlno_trno) + this.format4(this.registration.authTlno_txno) + this.format4(this.registration.authTlno_tsno)
      this.appfData.nmpt_namerCertiMthdTyp=(this.authCd === 'KMC' || this.authCd === 'SMS' )? 'M' : 'I'
      this.appfData.nmpt_namerCertiOrganTyp='1'//인증기관
      this.appfData.nmpt_namerCertiRequestNo=''
      this.appfData.nmpt_namerCertiResponseNo=''
      this.appfData.nmpt_namerCertiSuccessYn=(this.isAuth)?'Y':'N'
      this.appfData.nmpt_namerCertiTm=''
      this.appfData.nmpt_namerEncryptIdenNo=''//사용안함 암호주민등록번호
      this.appfData.nmpt_namerIdenNo=''//사용안함 주민등록번호
      this.appfData.nmpt_namerIdenNo1=''//사용안함 주민번호앞자리
      this.appfData.nmpt_namerIdenNo2=''//사용안함 주민번호뒷자리
      this.appfData.nmpt_namerIdenNoTyp='01'//hardCoding 주민번호타입
      this.appfData.nmpt_namerNm=this.registration.name
      this.appfData.nmpt_namerPtTelNo= this.format4(this.registration.moveInfo.titleHolder.phonNo_trno) + this.format4(this.registration.moveInfo.titleHolder.phonNo_txno) + this.format4(this.registration.moveInfo.titleHolder.phonNo_tsno)
      this.appfData.nmpt_namerPtTelNo1=(this.registration.moveInfo.titleHolder.phonNo_trno)?this.registration.moveInfo.titleHolder.phonNo_trno:''
      this.appfData.nmpt_namerPtTelNo2=(this.registration.moveInfo.titleHolder.phonNo_txno)?this.registration.moveInfo.titleHolder.phonNo_txno:''
      this.appfData.nmpt_namerPtTelNo3=(this.registration.moveInfo.titleHolder.phonNo_tsno)?this.registration.moveInfo.titleHolder.phonNo_tsno:''
      this.appfData.nmpt_namerTelNo= this.format4(this.registration.moveInfo.titleHolder.tlno_trno) + this.format4(this.registration.moveInfo.titleHolder.tlno_txno) + this.format4(this.registration.moveInfo.titleHolder.tlno_tsno)
      this.appfData.nmpt_namerTelNo1=(this.registration.moveInfo.titleHolder.tlno_trno)?this.registration.moveInfo.titleHolder.tlno_trno:''
      this.appfData.nmpt_namerTelNo2=(this.registration.moveInfo.titleHolder.tlno_txno)?this.registration.moveInfo.titleHolder.tlno_txno:''
      this.appfData.nmpt_namerTelNo3=(this.registration.moveInfo.titleHolder.tlno_tsno)?this.registration.moveInfo.titleHolder.tlno_tsno:''
      this.appfData.nmpt_nmptNo=(this.registration.moveInfo.moveTlno)?this.registration.moveInfo.moveTlno:''
      this.appfData.nmpt_nmptNo1=(this.registration.moveInfo.trno)?this.registration.moveInfo.trno:''
      this.appfData.nmpt_nmptNo2=(this.registration.moveInfo.txno)?this.registration.moveInfo.txno:''
      this.appfData.nmpt_nmptNo3=(this.registration.moveInfo.tsno)?this.registration.moveInfo.tsno:''
      this.appfData.nmpt_reqInfoCheck='Y'//약관확인여부
      this.appfData.nmpt_billCntcInfoKdCd=(this.registration.moveInfo.contractInfoCode)?this.registration.moveInfo.contractInfoCode:''//청구계약정보 종류
      this.appfData.nmpt_billCntcInfo1=(this.registration.moveInfo.contractInfoDetail)?this.registration.moveInfo.contractInfoDetail:''//청구계약정보
      this.appfData.appcTyp='HOM'//hardCoding
      this.appfData.bcortmpProd='1;;Y'//prodCd 값이 없으므로 하드코딩과 마찬가지임
      this.appfData.bcortmpSvc='1;;M;3;1;0'//prodCd 값이 없으므로 하드코딩과 마찬가지임
      let tmpSvcCustHopeYmd = new Date()
      tmpSvcCustHopeYmd.setDate(new Date().getDate() + 3)
      this.appfData.svcCustHopeYmd=tmpSvcCustHopeYmd.getFullYear().toString() + ((tmpSvcCustHopeYmd.getMonth()+1 < 10) ? '0'+ (tmpSvcCustHopeYmd.getMonth()+1) : tmpSvcCustHopeYmd.getMonth()+1).toString() + ((tmpSvcCustHopeYmd.getDate() < 10) ? '0'+ tmpSvcCustHopeYmd.getDate() : tmpSvcCustHopeYmd.getDate()).toString()//가청약상태 신청일시
      this.appfData.tmpAplyStTyp='1'//가신청상태구분 // 1:등록,2:완료,3:취소,4:불가,5:임시저장,6:청약취소

      let tmpMonth = new Date().getMonth() + 1
      tmpMonth = (tmpMonth < 10) ? '0' + tmpMonth : tmpMonth.toString()
      this.appfData.tmpAplyYmd=new Date().getFullYear().toString()+ tmpMonth +new Date().getDate().toString()//왜하는거지..
      this.appfData.tmpAplyTs=new Date().getHours().toString() + new Date().getMinutes().toString() + new Date().getSeconds().toString()//왜하는거지..
      this.appfData.custRegIp=(this.ipAddr)?this.ipAddr:''//사용자 IP
      this.appfData.rmk=''//사용안함
      this.appfData.AttrPath=''//사용안함
      this.appfData.custAgreeRegYn='Y'//고객 정보 활용 동의 등록 여부 TODO step3에서 갈 시 'Y' step2에서 바로 신청 시 'N' --> custInfoOfferCnsntYn와 연관
      this.appfData.extCallYn='N'//SP호출여부 hardCoding
      this.appfData.workFlag='I'//hompage 입력 flag hardcoding
      this.appfData.rtnurl= 'http://' + window.location.hostname + '/onsaleHome'//TODO URL 변경 시 변경

      let today = new Date().getFullYear().toString()
      today += (new Date().getMonth() + 1 < 10 ) ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1).toString()
      today += new Date().getDate().toString()
      today += new Date().getHours().toString()
      today += new Date().getMinutes().toString()
      today += new Date().getSeconds().toString()
      today += new Date().getMilliseconds().toString().substr(0,2)
      this.appfData.DupChkId=today.toString()
      this.appfData.custInfoOfferCnsntYn='Y'//TODO  070단독상품추가 신청이 가능 여부 판단하기 위한 변수 --> 단독상품이면 step3으로 넘어갈 필요가 없다.
      this.appfData.dpstrIdenNo=''//납부정보 테스트하드코딩..
      this.appfData.accdNo=''//납부정보 테스트하드코딩..
      this.appfData.accdNo1=''//납부정보 테스트하드코딩..
      this.appfData.homepageTest='Y'//hardCoding..
      this.appfData.mailTyp='2'//hardCoding..
      this.appfData.custChk='Y'//hardCoding..
      this.appfData.sendconfirm='Y'//hardCoding..
      // this.appfData.moct_birthDay=''//인증 생년월일 ex)940126--> 인증 단계에서 적용
      // this.appfData.moct_name=''//인증 이름--> 인증 단계에서 적용
      // this.appfData.moct_phoneNo=''//인증휴대폰번호--> 인증 단계에서 적용
      // this.appfData.ipinCi=''//ipinCi --> 인증 단계에서 적용
      this.appfData.snglSppsRqstYn=tmpSnglSppsRqstYn

      let tmpGender =''
      if(this.registration.birthYear < '2000'){
        if(this.registration.isDomestic === 'F'){
          if(this.registration.sex === 'M') tmpGender = '5'
          else tmpGender = '6'
        }else{
          if(this.registration.sex === 'M') tmpGender = '1'
          else tmpGender = '2'
        }
      }
      else{
        if(this.registration.isDomestic === 'F'){
          if(this.registration.sex === 'M') tmpGender = '7'
          else tmpGender = '8'
        }else{
          if(this.registration.sex === 'M') tmpGender = '3'
          else tmpGender = '4'
        }
      }
      this.appfData.custrnmBday=this.registration.birthYear.substr(2,2) + this.registration.birthMonth + this.registration.birthDate +tmpGender
      this.appfData.entrRsvRqstDvCd=(this.service.isHome)?'':'04'//''->home //04 ->soho
      this.appfData.line_cnt=(this.service.line_cnt)?this.service.line_cnt:''
      this.appfData.chk_Y_0='Y'//약관동의(step3)->필수약관동의이기 때문에 'Y'라고 가정 TODO step2에서 바로 신청서 저장 시 빈 값
      this.appfData.chk_Y_1=(this.agreement.personalInfoOptional)?'Y':'N'//선택
      this.appfData.chk_Y_2=''//선택약관동의(step3)->필수약관동의이기 때문에 'Y'라고 가정 TODO step2에서 바로 신청서 저장 시 빈 값
      this.appfData.chk_Y_4=''//선택약관동의(step3)->필수약관동의이기 때문에 'Y'라고 가정 TODO step2에서 바로 신청서 저장 시 빈 값
      this.appfData.macAddress=this.macAddr //mac Address
      // this.appfData.cnvgNo=''//서비스 추가 시 사용
      // this.appfData.sbcContNo=''//서비스 추가 시 사용
      this.appfData.homeTPSActivationProductList=[
        {prodCd : prodCd0 ,svcCd : svcCd0},
        {prodCd : prodCd1 ,svcCd : svcCd1},
        {prodCd : prodCd2 ,svcCd : svcCd2},
        {prodCd : prodCd3 ,svcCd : svcCd3},
      ]

      this.$store.commit('saveTpsInfo', this.appfData)
      return true
    },

    clickIsHome(){
      this.service.isHome = false
      this.service.moveYn = false
    },

    clickMoveYn(){
      this.service.moveYn = false
    },

    clickCheckExclusive(){
      if(this.service.chkExclusive){
        this.service.chkInternet = false;
        this.service.chkInternetPhone = false;
        this.service.moveYn = false;
        this.service.chkTV = false;
        this.service.chkIoT = false;
      }
      else{
        this.service.chkInternet = true;
        this.service.chkInternetPhone = false;
        this.service.moveYn = false;
        this.service.chkTV = false;
        this.service.chkIoT = false;
      }
    },

    searchPopupClose(result){
      if (result.id === 'ok') {
        this.registration.dealer.selrId = result.ok.selrId
        this.registration.dealer.selrTyp = result.ok.selrTyp
        this.registration.dealer.tmpAplyTyp = result.ok.tmpAplyTyp
        this.registration.dealer.csalesCd = result.ok.csalesCd
        this.registration.dealer.rmk = result.ok.rmk
        this.registration.dealer.selTyp = result.ok.selTyp
        this.registration.dealer.selPathCd = result.ok.selPathCd
        this.registration.dealer.selChnlTyp = result.ok.selChnlTyp
        this.registration.dealer.zipCd = result.ok.zipCd
        this.registration.dealer.allAddr = result.ok.allAddr
        this.registration.dealer.telNo = result.ok.telNo
        this.registration.dealer.email = result.ok.email
        this.registration.dealer.dlrCd = result.ok.dlrCd
        this.registration.dealer.dlrGrpCd = result.ok.dlrGrpCd
        this.registration.dealer.spare1 = result.ok.spare1
        this.registration.dealer.spare2 = result.ok.spare2
        this.registration.dealer.posCd = result.ok.posCd  //add_20201021_posCd  

        this.registration.dealerInfo =  this.registration.dealer.spare2 + "(" + this.registration.dealer.spare1 + "/" + this.registration.dealer.rmk + ")"
      }
    },

    popupClose(result) {
      if (result.id === 'ok') {
        this.registration.crplZpcd = result.ok.zip
        this.registration.crplAddr = result.ok.roadAddr1
        this.registration.crplDadr = result.ok.addrDetail
        this.registration.addr1 = result.ok.addr1
        this.registration.addr2 = result.ok.addr2
        this.registration.roadAddr1 = result.ok.roadAddr1
        this.registration.roadAddr2 = result.ok.roadAddr2


        //주소 재검색 시 번호이동 확인정보 새로 세팅
        this.registration.moveInfo.trno = ''
        this.registration.moveInfo.txno = ''
        this.registration.moveInfo.tsno = ''
        this.registration.moveInfo.moveTlno = ''
        this.registration.moveInfo.beforeBuisness = ''
        this.editNumbers()

        this.$refs.search.focus()
      }
    },
  }
}
</script>

<style scoped>

</style>
